<template>
  <div class="flex al-center">
    <svg
      v-if="name == 'connect'"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <g
        id="Group_1825"
        data-name="Group 1825"
        transform="translate(-1744 -4284)"
      >
        <g
          id="Group_4503"
          data-name="Group 4503"
          transform="translate(212.827 692.863)"
        >
          <rect
            id="Rectangle_111"
            data-name="Rectangle 111"
            width="30"
            height="30"
            rx="4"
            transform="translate(1531.173 3591.137)"
            fill="#1a1a1a"
          />
          <g
            id="Group_351"
            data-name="Group 351"
            transform="translate(1537.269 3596.767)"
          >
            <path
              id="Path_236"
              data-name="Path 236"
              d="M20.512,19.721a7.292,7.292,0,1,1,0-8.562V7.865a9.594,9.594,0,1,0,.035,15.183Z"
              transform="translate(-5.068 -5.875)"
              fill="#fff"
              fill-rule="evenodd"
            />
          </g>
        </g>
      </g>
    </svg>
    <svg
      v-if="name == 'copyright'"
      xmlns="http://www.w3.org/2000/svg"
      width="22.768"
      height="30"
      viewBox="0 0 22.768 30"
    >
      <g
        id="Group_252"
        data-name="Group 252"
        transform="translate(-695.331 -666.619)"
      >
        <path
          id="Path_104"
          data-name="Path 104"
          d="M620.34,472.69v1.852H624.5l-4.159,4.249,1.282,1.31,4.159-4.249V480.1h1.814V472.69Z"
          transform="translate(78.214 213.46)"
          fill="#3269e5"
        />
        <path
          id="Path_105"
          data-name="Path 105"
          d="M676.544,474.542V472.69H669.29V480.1H671.1v-4.249l4.159,4.249,1.282-1.31-4.159-4.249Z"
          transform="translate(38.331 213.46)"
          fill="#40adec"
        />
        <path
          id="Path_106"
          data-name="Path 106"
          d="M672.385,428.237l4.159-4.248-1.282-1.31-4.159,4.248V422.68H669.29v7.411h7.254v-1.854Z"
          transform="translate(38.331 254.206)"
          fill="#e50b09"
        />
        <path
          id="Path_107"
          data-name="Path 107"
          d="M625.781,422.68v4.248l-4.159-4.248-1.282,1.31,4.159,4.248H620.34v1.854h7.254V422.68Z"
          transform="translate(78.214 254.206)"
          fill="#ffc900"
        />
        <path
          id="Path_108"
          data-name="Path 108"
          d="M625.708,428.954H602.94V406.16h22.768Zm-21.149-1.619h19.53V407.779h-19.53Z"
          transform="translate(92.391 267.665)"
          fill="#1a1a1a"
        />
        <path
          id="Path_109"
          data-name="Path 109"
          d="M646.237,376.039H635.55V372.6a5.35,5.35,0,0,1,5.344-5.344h0a5.35,5.35,0,0,1,5.344,5.344Zm-9.077-1.619h7.458V372.6a3.725,3.725,0,1,0-7.449,0Z"
          transform="translate(65.822 299.359)"
          fill="#1a1a1a"
        />
      </g>
    </svg>
    <svg
      v-if="name == 'eng-logo'"
      width="205.886"
      height="26"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 923.24 126.85"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            class="cls-1"
            d="M102.57 41.29V11.73C95.3 6.11 83.24 0 64.91 0 28.08 0 0 28.24 0 63.42c0 35.51 28.41 63.42 64.91 63.42 18.33 0 30.39-6.28 37.66-11.89V85.39c-8.81 7.09-21.14 13.71-33.7 13.71-21.14 0-37.49-14.2-37.49-35.68 0-21 15.36-35.68 37.49-35.68 12.88 0 24.36 6.44 33.69 13.54M126.18 2.15h29.73V125.2h-29.73zM273.9 29.89V2.15h-98.11v27.74h34.19v95.3h29.56v-95.3h34.36zM403.88 2.15h-33.36l-27.91 45.58-27.92-45.58H281.5l46.41 75.97v47.07h29.56V78.12l46.41-75.97zM679.68 74.49h-21.31l10.57-34.35Zm10.08 27.58L698 125.2h30.56l-44.43-123h-30.22l-44.43 123H640l8.26-23.12ZM824.8 97.45h-44.54V2.15h-31.93v123.04h76.47V97.45zM923.24 97.45H878.7V2.15h-31.93v123.04h76.47V97.45zM593.36 2.15h-28.58l-28.13 49.38-28.52-49.38h-28.19v123.04h28.96V54.34l2.25 3.51 20.05 35.08h10.74l20.78-35.71 1.68-2.88v70.85h28.96V2.15z"
          />
        </g>
      </g>
    </svg>
    <svg
      v-if="name == 'card'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="31.471"
      height="20"
      viewBox="0 0 31.471 20"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="Path_5100"
            data-name="Path 5100"
            d="M-811.817,166.019v2.893h4.251l-3.93,4.056,2.116,2.183,3.931-4.056v4.387h2.8v-9.463Zm0-4.814V164.1h11.031v11.383h2.023a.793.793,0,0,0,.78-.805V161.943a.727.727,0,0,0-.715-.738Z"
            transform="translate(811.817 -161.205)"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <rect
            id="Rectangle_1137"
            data-name="Rectangle 1137"
            width="13.835"
            height="14.277"
            fill="none"
          />
        </clipPath>
        <pattern
          id="pattern"
          preserveAspectRatio="none"
          width="100%"
          height="100%"
          viewBox="0 0 108 111"
        >
          <image
            width="108"
            height="111"
            xlink:href="data:image/png;base64,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"
          />
        </pattern>
        <clipPath id="clip-path-4">
          <path
            id="Path_5102"
            data-name="Path 5102"
            d="M-906.783,209.795a.319.319,0,0,0-.319.32v2.627a.319.319,0,0,0,.319.32H-903a.32.32,0,0,0,.32-.32v-2.627a.32.32,0,0,0-.32-.32Z"
            transform="translate(907.102 -209.795)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient"
          x1="21.844"
          y1="13.107"
          x2="21.868"
          y2="13.107"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#7e8083" />
          <stop offset="0.607" stop-color="#fefefe" />
          <stop offset="1" stop-color="#848689" />
        </linearGradient>
        <clipPath id="clip-path-5">
          <path
            id="Path_5112"
            data-name="Path 5112"
            d="M-919.158,161.905a.863.863,0,0,0,.882.862.813.813,0,0,0,.512-.162v-.4a.771.771,0,0,1-.458.186.48.48,0,0,1-.51-.485.476.476,0,0,1,.51-.485.775.775,0,0,1,.458.184v-.4a.814.814,0,0,0-.512-.159.863.863,0,0,0-.882.862"
            transform="translate(919.158 -161.043)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-2"
          x1="56.264"
          y1="32.423"
          x2="56.327"
          y2="32.423"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#dddbdb" />
          <stop offset="0.458" stop-color="#dddbdb" />
          <stop offset="0.546" stop-color="#d7d5d4" />
          <stop offset="0.663" stop-color="#c6c5c3" />
          <stop offset="0.797" stop-color="#abaaa8" />
          <stop offset="0.942" stop-color="#868581" />
          <stop offset="1" stop-color="#767570" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="77.76"
          y1="45.296"
          x2="77.853"
          y2="45.296"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#383531" />
          <stop offset="0.537" stop-color="#5f5954" />
          <stop offset="0.729" stop-color="#5f5a54" />
          <stop offset="1" stop-color="#767570" />
        </linearGradient>
        <clipPath id="clip-path-6">
          <rect
            id="Rectangle_1141"
            data-name="Rectangle 1141"
            width="0.404"
            height="1.673"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-4"
          x1="96.573"
          y1="42.579"
          x2="96.683"
          y2="42.579"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-5"
          x1="198.773"
          y1="44.872"
          x2="199.096"
          y2="44.872"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-7">
          <path
            id="Path_5115"
            data-name="Path 5115"
            d="M-900.98,161.266v.377h.465v1.3h.4v-1.3h.467v-.377Z"
            transform="translate(900.98 -161.266)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-6"
          x1="57.419"
          y1="33.857"
          x2="57.485"
          y2="33.857"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-7"
          x1="79.12"
          y1="46.638"
          x2="79.218"
          y2="46.638"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-8">
          <path
            id="Path_5117"
            data-name="Path 5117"
            d="M-888.749,161.205l-.379.62-.38-.62h-.451l.631,1.033v.64h.4v-.64l.631-1.033Z"
            transform="translate(889.959 -161.205)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-8"
          x1="49.642"
          y1="31.596"
          x2="49.7"
          y2="31.596"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-9"
          x1="64.039"
          y1="46.818"
          x2="64.117"
          y2="46.818"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-9">
          <path
            id="Path_5119"
            data-name="Path 5119"
            d="M-870.35,161.206l-.382.671-.388-.671h-.383v1.673h.393v-.963l.3.525h.146l.305-.525v.963h.394v-1.673Z"
            transform="translate(871.503 -161.206)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-10"
          x1="51.127"
          y1="32.852"
          x2="51.187"
          y2="32.852"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-11"
          x1="66.988"
          y1="46.759"
          x2="67.072"
          y2="46.759"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-10">
          <path
            id="Path_5121"
            data-name="Path 5121"
            d="M-857.471,161.722l.146.467h-.29Zm-.2-.516-.6,1.673h.415l.112-.314h.564l.112.314h.415l-.6-1.673Z"
            transform="translate(858.279 -161.206)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-12"
          x1="48.651"
          y1="31.904"
          x2="48.709"
          y2="31.904"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-13"
          x1="63.065"
          y1="46.797"
          x2="63.145"
          y2="46.797"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-11">
          <path
            id="Path_5123"
            data-name="Path 5123"
            d="M-844.6,161.205v1.673h.95V162.5h-.546v-1.3Z"
            transform="translate(844.601 -161.205)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-14"
          x1="64.559"
          y1="37.295"
          x2="64.637"
          y2="37.295"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-15"
          x1="98.428"
          y1="46.321"
          x2="98.566"
          y2="46.321"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-12">
          <path
            id="Path_5125"
            data-name="Path 5125"
            d="M-835.824,161.205v1.673h.95V162.5h-.546v-1.3Z"
            transform="translate(835.824 -161.205)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-16"
          x1="63.873"
          y1="37.297"
          x2="63.952"
          y2="37.297"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-17"
          x1="97.224"
          y1="46.321"
          x2="97.361"
          y2="46.321"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-13">
          <path
            id="Path_5127"
            data-name="Path 5127"
            d="M-918.876,181.57a.546.546,0,0,0-.207.208.571.571,0,0,0-.074.286.577.577,0,0,0,.073.286.558.558,0,0,0,.2.208.523.523,0,0,0,.281.078.576.576,0,0,0,.3-.075.507.507,0,0,0,.2-.224.824.824,0,0,0,.072-.361h-.638v.25h.341a.256.256,0,0,1-.1.118.321.321,0,0,1-.167.041.275.275,0,0,1-.151-.041.274.274,0,0,1-.1-.115.375.375,0,0,1-.035-.164.341.341,0,0,1,.04-.164.29.29,0,0,1,.112-.115.325.325,0,0,1,.166-.042.258.258,0,0,1,.137.036.321.321,0,0,1,.1.089l.2-.153a.6.6,0,0,0-.19-.163.5.5,0,0,0-.243-.059.594.594,0,0,0-.3.077"
            transform="translate(919.158 -181.493)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-18"
          x1="85.031"
          y1="55.545"
          x2="85.115"
          y2="55.545"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-19"
          x1="94.323"
          y1="65.774"
          x2="94.44"
          y2="65.774"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-14">
          <rect
            id="Rectangle_1150"
            data-name="Rectangle 1150"
            width="0.266"
            height="1.111"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-20"
          x1="123.963"
          y1="113.22"
          x2="124.082"
          y2="113.22"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-21"
          x1="236.729"
          y1="63.325"
          x2="237.219"
          y2="63.325"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-15">
          <path
            id="Path_5130"
            data-name="Path 5130"
            d="M-906.606,181.613v1.111h.266v-.416H-906v-.25h-.344v-.194h.391v-.25Z"
            transform="translate(906.606 -181.613)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-22"
          x1="103.453"
          y1="78.129"
          x2="103.554"
          y2="78.129"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-23"
          x1="143.687"
          y1="66.613"
          x2="143.885"
          y2="66.613"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-16">
          <path
            id="Path_5132"
            data-name="Path 5132"
            d="M-900.546,181.613v.25h.25v.861h.266v-.861h.25v-.25Z"
            transform="translate(900.546 -181.613)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-24"
          x1="97.225"
          y1="70.943"
          x2="97.322"
          y2="70.943"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-25"
          x1="126.415"
          y1="66.952"
          x2="126.585"
          y2="66.952"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-17">
          <path
            id="Path_5134"
            data-name="Path 5134"
            d="M-891.457,181.687a.539.539,0,0,0-.2.206.579.579,0,0,0-.074.291.578.578,0,0,0,.074.291.539.539,0,0,0,.2.206.549.549,0,0,0,.28.074.5.5,0,0,0,.2-.035.561.561,0,0,0,.126-.072v-.266a.289.289,0,0,1-.052.048.372.372,0,0,1-.1.052.4.4,0,0,1-.138.023.348.348,0,0,1-.163-.039.3.3,0,0,1-.119-.112.324.324,0,0,1-.044-.17.325.325,0,0,1,.044-.17.3.3,0,0,1,.119-.112.346.346,0,0,1,.163-.039.4.4,0,0,1,.138.023.371.371,0,0,1,.1.052.283.283,0,0,1,.052.048v-.266a.56.56,0,0,0-.126-.072.5.5,0,0,0-.2-.035.549.549,0,0,0-.28.074"
            transform="translate(891.734 -181.613)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-26"
          x1="90.055"
          y1="64.383"
          x2="90.147"
          y2="64.383"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-27"
          x1="111.65"
          y1="65.385"
          x2="111.798"
          y2="65.385"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-18">
          <path
            id="Path_5136"
            data-name="Path 5136"
            d="M-883.887,182.077l.111.31H-884Zm-.152-.343-.4,1.111h.276l.075-.208h.4l.075.208h.275l-.4-1.111Z"
            transform="translate(884.439 -181.734)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-28"
          x1="83.733"
          y1="56.392"
          x2="83.819"
          y2="56.392"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-29"
          x1="91.509"
          y1="67.585"
          x2="91.627"
          y2="67.585"
          xlink:href="#linear-gradient-3"
        />
        <clipPath id="clip-path-19">
          <path
            id="Path_5138"
            data-name="Path 5138"
            d="M-875.039,181.984h.18a.158.158,0,0,1,.11.039.136.136,0,0,1,.043.106.137.137,0,0,1-.043.107.157.157,0,0,1-.11.039h-.18Zm-.266-.25v1.111h.266v-.319h.131l.185.319h.3l-.216-.374a.38.38,0,0,0,.146-.139.38.38,0,0,0,.054-.2.374.374,0,0,0-.059-.209.4.4,0,0,0-.155-.139.45.45,0,0,0-.206-.048Z"
            transform="translate(875.305 -181.734)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-30"
          x1="88.668"
          y1="63.873"
          x2="88.761"
          y2="63.873"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-20">
          <path
            id="Path_5139"
            data-name="Path 5139"
            d="M-867.144,181.984H-867a.276.276,0,0,1,.2.076.3.3,0,0,1,.079.229.3.3,0,0,1-.079.229.276.276,0,0,1-.2.076h-.146Zm-.266-.25v1.111H-867a.54.54,0,0,0,.279-.074.523.523,0,0,0,.195-.2.571.571,0,0,0,.071-.282.571.571,0,0,0-.071-.282.523.523,0,0,0-.195-.2.538.538,0,0,0-.279-.074Z"
            transform="translate(867.41 -181.734)"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-31"
          x1="86.399"
          y1="61.484"
          x2="86.49"
          y2="61.484"
          xlink:href="#linear-gradient-2"
        />
      </defs>
      <g
        id="Group_7652"
        data-name="Group 7652"
        transform="translate(929.564 0)"
      >
        <path
          id="Path_5099"
          data-name="Path 5099"
          d="M-928.5,146.464a1.069,1.069,0,0,0-1.068,1.063V165.4a1.069,1.069,0,0,0,1.068,1.063h29.333a1.069,1.069,0,0,0,1.068-1.063V147.527a1.069,1.069,0,0,0-1.068-1.063Z"
          transform="translate(0 -146.464)"
          fill="#313133"
        />
        <g
          id="Group_7617"
          data-name="Group 7617"
          transform="translate(-914.212 1.922)"
        >
          <g
            id="Group_7616"
            data-name="Group 7616"
            transform="translate(0 0)"
            clip-path="url(#clip-path)"
          >
            <g
              id="Group_7615"
              data-name="Group 7615"
              transform="translate(0 0)"
            >
              <g id="Group_7614" data-name="Group 7614">
                <g
                  id="Group_7613"
                  data-name="Group 7613"
                  clip-path="url(#clip-path-2)"
                >
                  <g id="Group_7612" data-name="Group 7612">
                    <g
                      id="Group_7611"
                      data-name="Group 7611"
                      clip-path="url(#clip-path-2)"
                    >
                      <rect
                        id="Rectangle_1135"
                        data-name="Rectangle 1135"
                        width="13.894"
                        height="14.332"
                        transform="translate(-0.045 -0.023)"
                        fill="url(#pattern)"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          id="Path_5101"
          data-name="Path 5101"
          d="M-903.514,209.517h-3.709a.41.41,0,0,0-.424.393V212.5a.41.41,0,0,0,.424.393h3.709a.41.41,0,0,0,.424-.393V209.91a.41.41,0,0,0-.424-.393"
          transform="translate(-19.059 -201.296)"
          fill="#c7c8ca"
        />
        <line
          id="Line_59"
          data-name="Line 59"
          x1="1.154"
          transform="translate(-926.459 8.277)"
          fill="none"
          stroke="#7c7c7b"
          stroke-miterlimit="10"
          stroke-width="0.3"
        />
        <g
          id="Group_7619"
          data-name="Group 7619"
          transform="translate(-926.635 8.257)"
        >
          <g
            id="Group_7618"
            data-name="Group 7618"
            transform="translate(0 0)"
            clip-path="url(#clip-path-4)"
          >
            <rect
              id="Rectangle_1138"
              data-name="Rectangle 1138"
              width="5.338"
              height="5.489"
              transform="translate(-1.605 1.934) rotate(-50.31)"
              fill="url(#linear-gradient)"
            />
          </g>
        </g>
        <path
          id="Path_5103"
          data-name="Path 5103"
          d="M-895.989,213.145a1.533,1.533,0,0,1-.632-1.072c0-.1.081-.418.08-.546s-.075-.421-.08-.517a1.623,1.623,0,0,1,.632-1.1h.489a1.623,1.623,0,0,1,.632,1.1c0,.1-.081.388-.08.517s.075.451.08.546a1.533,1.533,0,0,1-.632,1.072Z"
          transform="translate(-28.648 -201.635)"
          fill="none"
          stroke="#7c7c7b"
          stroke-miterlimit="10"
          stroke-width="0.3"
        />
        <line
          id="Line_60"
          data-name="Line 60"
          x1="1.365"
          transform="translate(-926.634 10.438)"
          fill="none"
          stroke="#7c7c7b"
          stroke-miterlimit="10"
          stroke-width="0.3"
        />
        <line
          id="Line_61"
          data-name="Line 61"
          x1="1.365"
          transform="translate(-926.634 9.394)"
          fill="none"
          stroke="#7c7c7b"
          stroke-miterlimit="10"
          stroke-width="0.3"
        />
        <line
          id="Line_62"
          data-name="Line 62"
          x1="1.114"
          transform="translate(-923.522 8.277)"
          fill="none"
          stroke="#7c7c7b"
          stroke-miterlimit="10"
          stroke-width="0.3"
        />
        <line
          id="Line_63"
          data-name="Line 63"
          x1="1.114"
          transform="translate(-923.522 11.5)"
          fill="none"
          stroke="#7c7c7b"
          stroke-miterlimit="10"
          stroke-width="0.3"
        />
        <line
          id="Line_64"
          data-name="Line 64"
          x1="1.296"
          transform="translate(-923.517 10.438)"
          fill="none"
          stroke="#7c7c7b"
          stroke-miterlimit="10"
          stroke-width="0.3"
        />
        <line
          id="Line_65"
          data-name="Line 65"
          x1="1.296"
          transform="translate(-923.517 9.394)"
          fill="none"
          stroke="#7c7c7b"
          stroke-miterlimit="10"
          stroke-width="0.3"
        />
        <path
          id="Path_5104"
          data-name="Path 5104"
          d="M-867.124,214.24a.53.53,0,0,1,.077.147.532.532,0,0,1,.028.17.533.533,0,0,1-.028.17.532.532,0,0,1-.077.147.136.136,0,0,0,.028.191.137.137,0,0,0,.191-.028.8.8,0,0,0,.116-.223.8.8,0,0,0,.042-.257.809.809,0,0,0-.042-.257.81.81,0,0,0-.116-.223.136.136,0,0,0-.191-.028.135.135,0,0,0-.029.19m.467-.254h0a1.083,1.083,0,0,1,.162.571,1.083,1.083,0,0,1-.162.571.136.136,0,0,0,.045.187.136.136,0,0,0,.188-.044,1.354,1.354,0,0,0,.2-.714,1.356,1.356,0,0,0-.2-.714.136.136,0,0,0-.188-.044.137.137,0,0,0-.045.187m.5-.259h0a1.636,1.636,0,0,1,.224.83,1.632,1.632,0,0,1-.224.83.137.137,0,0,0,.049.187.137.137,0,0,0,.187-.049,1.915,1.915,0,0,0,.261-.968,1.916,1.916,0,0,0-.261-.968.136.136,0,0,0-.186-.049.136.136,0,0,0-.049.187m.493-.26a.137.137,0,0,1,.051-.186.136.136,0,0,1,.185.051,2.467,2.467,0,0,1,.324,1.225,2.465,2.465,0,0,1-.324,1.224.136.136,0,0,1-.185.051.137.137,0,0,1-.051-.186,2.193,2.193,0,0,0,.288-1.09,2.195,2.195,0,0,0-.288-1.09"
          transform="translate(-54.275 -204.554)"
          fill="#8a8a8e"
          fill-rule="evenodd"
        />
        <path
          id="Path_5105"
          data-name="Path 5105"
          d="M-747.03,277.392l-.468,2.188h-.566l.468-2.188Zm2.381,1.412.3-.822.171.822Zm.632.775h.523l-.457-2.188h-.484a.257.257,0,0,0-.241.16l-.849,2.027h.594l.118-.327h.726Zm-1.477-.714c0-.578-.8-.609-.793-.868,0-.079.076-.161.24-.183a1.064,1.064,0,0,1,.558.1l.1-.464a1.505,1.505,0,0,0-.529-.1c-.559,0-.953.3-.957.723,0,.315.281.491.5.6s.294.176.294.272c0,.147-.176.211-.338.214a1.192,1.192,0,0,1-.582-.138l-.1.479a1.711,1.711,0,0,0,.63.116c.594,0,.983-.293.985-.748m-2.344-1.474h-.595l-.589,1.489-.238-1.266a.264.264,0,0,0-.261-.223h-.963l-.014.063a2.322,2.322,0,0,1,.558.187.238.238,0,0,1,.135.191l.451,1.746h.6Z"
          transform="translate(-155.719 -260.285)"
          fill="#fff"
          fill-rule="evenodd"
        />
        <path
          id="Path_5106"
          data-name="Path 5106"
          d="M-842.329,268.612l-.159-.443h.1l.115.329.107-.329h.1l-.159.443Zm.654,0-.177-.443h-.1l-.174.443h.1l.037-.1h.181l.037.1Zm-.163-.177h-.122l.059-.163Zm.214.177h0v-.44h.089v.366h.226v.074Zm.374,0h0v-.443h.092v.443Zm.177-.443h.163a.438.438,0,0,1,.085.007.149.149,0,0,1,.067.041.206.206,0,0,1,.044.074.381.381,0,0,1,.015.1.345.345,0,0,1-.015.1.163.163,0,0,1-.048.078.2.2,0,0,1-.063.037.437.437,0,0,1-.081.007h-.166Zm.089.074h0v.3h.066c.026,0,.044,0,.056,0a.116.116,0,0,0,.037-.019.222.222,0,0,0,.022-.044.249.249,0,0,0,.008-.081.226.226,0,0,0-.008-.078.123.123,0,0,0-.026-.044.087.087,0,0,0-.04-.022c-.011,0-.037,0-.074,0Zm-1.36,1.064h0v-.37h-.133v-.074h.355v.074h-.129v.37Zm.281,0h0v-.443h.089v.174h.177v-.174h.089v.443h-.089v-.192h-.177v.192Zm.447,0h0v-.443h.192a.365.365,0,0,1,.1.011.133.133,0,0,1,.052.041.152.152,0,0,1,.019.07.124.124,0,0,1-.03.085.142.142,0,0,1-.089.041.165.165,0,0,1,.048.037.4.4,0,0,1,.052.074l.055.085h-.107l-.067-.1a.539.539,0,0,0-.048-.067.07.07,0,0,0-.026-.018.147.147,0,0,0-.044,0h-.019v.185Zm.092-.255h.067a.333.333,0,0,0,.081-.007c.007,0,.018-.007.022-.019a.047.047,0,0,0,.011-.033.064.064,0,0,0-.011-.037.116.116,0,0,0-.037-.019h-.133Zm.359-.188h.089v.24a.363.363,0,0,0,0,.074.089.089,0,0,0,.026.044.1.1,0,0,0,.059.019.093.093,0,0,0,.059-.019.078.078,0,0,0,.022-.037.378.378,0,0,0,0-.078v-.244h.092v.233a.727.727,0,0,1-.008.115.133.133,0,0,1-.03.056.143.143,0,0,1-.052.037.261.261,0,0,1-.085.011.228.228,0,0,1-.1-.015.11.11,0,0,1-.052-.037.147.147,0,0,1-.026-.048.738.738,0,0,1-.008-.115Z"
          transform="translate(-75.723 -252.301)"
          fill="#fff"
          fill-rule="evenodd"
        />
        <path
          id="Path_5107"
          data-name="Path 5107"
          d="M-823.27,261.594v-.447h.133l.081.307.078-.307h.137v.447h-.085v-.351l-.089.351h-.085l-.088-.351v.351Zm.5-.222h0a.272.272,0,0,1,.022-.115.153.153,0,0,1,.04-.059.178.178,0,0,1,.055-.041.28.28,0,0,1,.1-.019.214.214,0,0,1,.159.063.226.226,0,0,1,.059.17.232.232,0,0,1-.059.17.2.2,0,0,1-.155.059.207.207,0,0,1-.159-.059.227.227,0,0,1-.059-.17m.092,0h0a.159.159,0,0,0,.037.115.11.11,0,0,0,.089.037.12.12,0,0,0,.089-.037.181.181,0,0,0,.033-.118.169.169,0,0,0-.033-.115.11.11,0,0,0-.089-.037.131.131,0,0,0-.093.037.18.18,0,0,0-.033.118m.41.222h0v-.447h.089l.181.3v-.3h.085v.447h-.092l-.181-.292v.292Zm.551,0h0v-.37h-.133v-.077h.351v.077h-.129v.37Zm.277,0h0v-.447h.092v.177h.174v-.177h.089v.447h-.089v-.2h-.174v.2Zm.576.007h0l.111-.462h.063l-.111.462Zm.5-.007h0v-.189l-.166-.259h.107l.1.177.1-.177h.1l-.163.259v.189Zm.3,0h0v-.447h.329v.077h-.236v.1h.222v.074h-.222v.122h.248v.074Zm.817,0h-.1l-.041-.1h-.177l-.037.1h-.1l.174-.447h.1Zm-.166-.177h0l-.059-.163-.063.163Zm.214.177h0v-.447h.189a.323.323,0,0,1,.1.015.1.1,0,0,1,.052.041.118.118,0,0,1,.019.07.13.13,0,0,1-.026.085.2.2,0,0,1-.089.04.24.24,0,0,1,.048.037.584.584,0,0,1,.052.07l.052.089h-.107l-.063-.1c-.026-.037-.04-.059-.048-.067a.12.12,0,0,0-.026-.018.159.159,0,0,0-.048,0h-.019v.185Zm.089-.259h.067a.39.39,0,0,0,.081,0,.068.068,0,0,0,.026-.019.055.055,0,0,0,.008-.033.056.056,0,0,0-.011-.037.051.051,0,0,0-.033-.019h-.137Z"
          transform="translate(-92.435 -246.187)"
          fill="#fff"
          fill-rule="evenodd"
        />
        <path
          id="Path_5108"
          data-name="Path 5108"
          d="M-801.879,268.139h.421a.157.157,0,0,0,.118-.041.159.159,0,0,0,.047-.132v-.305a.159.159,0,0,0-.047-.132.157.157,0,0,0-.118-.041h-.492a.069.069,0,0,0-.074.074.069.069,0,0,0,.074.074h.509v.355h-.415a.148.148,0,0,0-.168.168v.484h.657a.069.069,0,0,0,.074-.074.068.068,0,0,0-.074-.074h-.512Zm1.108-.022h0v-.556a.067.067,0,0,0-.072-.074.067.067,0,0,0-.074.074v.7h.434v.3a.066.066,0,0,0,.074.074c.055,0,.074-.028.074-.074v-.3a.069.069,0,0,0,.074-.074.068.068,0,0,0-.074-.074v-.429a.066.066,0,0,0-.074-.074.068.068,0,0,0-.074.074v.429Z"
          transform="translate(-110.91 -251.708)"
          fill="#fff"
        />
        <path
          id="Path_5109"
          data-name="Path 5109"
          d="M-824.089,267.777a.137.137,0,0,0-.137.137v.791a.137.137,0,0,0,.137.137h.4a.136.136,0,0,0,.137-.137v-.791a.136.136,0,0,0-.137-.137Zm0,.928h0v-.791h.4v.791Zm1.257,0h0v-.928h-.34a.062.062,0,0,0-.066.067.063.063,0,0,0,.066.07h.2v.791h-.2a.062.062,0,0,0-.066.066.065.065,0,0,0,.066.07h.539a.066.066,0,0,0,.07-.07v-.344a.062.062,0,0,0-.07-.07c-.051,0-.066.03-.066.07v.277Zm1.238-.809h0a.133.133,0,0,0,.015-.056.063.063,0,0,0-.066-.063c-.033,0-.052.022-.066.051l-.514.876a.168.168,0,0,0-.029.07.072.072,0,0,0,.07.067.077.077,0,0,0,.067-.048Z"
          transform="translate(-91.604 -251.96)"
          fill="#fff"
        />
        <path
          id="Path_5110"
          data-name="Path 5110"
          d="M-911.462,245.34v-1.357h-.5a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1h.3v1.157h-.3a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.79a.093.093,0,0,0,.1-.1v-.5a.089.089,0,0,0-.1-.1.088.088,0,0,0-.1.1v.4Zm1.045-.478h.564a.22.22,0,0,0,.163-.056.212.212,0,0,0,.059-.178v-.411a.212.212,0,0,0-.059-.178.221.221,0,0,0-.163-.056h-.664a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1h.686v.478h-.56a.2.2,0,0,0-.226.226v.652h.886a.093.093,0,0,0,.1-.1.091.091,0,0,0-.1-.1h-.686Zm2.028-.678h0v.334c0,.111-.044.144-.1.144h-.393a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.393c.056,0,.1.033.1.145v.334h-.69a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.69a.2.2,0,0,0,.2-.2v-.386a.239.239,0,0,0-.078-.193.24.24,0,0,0,.078-.193v-.386a.2.2,0,0,0-.2-.2h-.69a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1Zm.949.649h0v-.749a.091.091,0,0,0-.1-.1.093.093,0,0,0-.1.1v.949h.59v.408a.088.088,0,0,0,.1.1.088.088,0,0,0,.1-.1v-.408a.093.093,0,0,0,.1-.1.091.091,0,0,0-.1-.1v-.579a.09.09,0,0,0-.1-.1.091.091,0,0,0-.1.1v.579Zm2.981-.649h.489a.093.093,0,0,0,.1-.1.093.093,0,0,0-.1-.1h-.69v.878h.589v.478h-.463a.319.319,0,0,1-.1-.041l-.063-.026a.123.123,0,0,0-.063-.015.1.1,0,0,0-.1.1c0,.07.059.085.115.111l.074.033a.3.3,0,0,0,.133.037h.445a.192.192,0,0,0,.174-.07.212.212,0,0,0,.048-.156v-.426a.2.2,0,0,0-.063-.171.211.211,0,0,0-.159-.056h-.367Zm1.238,0h0a.1.1,0,0,0,.1-.1.1.1,0,0,0-.093-.1h-.118c-.071,0-.085.056-.085.1v1.331c0,.093.033.126.13.126h.727c.089,0,.13-.033.13-.126v-.449c0-.093-.019-.133-.119-.133h-.671Zm.589.849h0v.308h-.589v-.308Zm1.438-.849h0v.274c0,.089,0,.089-.059.145l-.278.237a.115.115,0,0,0-.052.119v.482a.088.088,0,0,0,.1.1c.074,0,.1-.037.1-.1v-.389c0-.07,0-.074.056-.119l.282-.245c.056-.044.052-.056.052-.122v-.582h-.886a.1.1,0,0,0-.1.1v.1a.1.1,0,0,0,.1.1.1.1,0,0,0,.1-.1Zm1.053.478h0v-.478h.189v.478Zm-.1-.678h0a.1.1,0,0,0-.1.1v.578a.2.2,0,0,0-.145.056.191.191,0,0,0-.055.144v.478a.187.187,0,0,0,.2.2h.59a.187.187,0,0,0,.2-.2v-.478a.189.189,0,0,0-.056-.144.212.212,0,0,0-.144-.056v-.578a.1.1,0,0,0-.1-.1Zm-.1,1.357h0v-.478h.59v.478Zm3.466,0h0a.1.1,0,0,0-.1.1.1.1,0,0,0,.1.1h.1a.1.1,0,0,0,.1-.1v-1.357a.1.1,0,0,0-.1-.1h-.786a.1.1,0,0,0-.1.1v.512a.1.1,0,0,0,.1.1h.686Zm-.586-.845h0v-.311h.586v.311Zm1.832.845h0v-1.357h-.493a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1h.293v1.157h-.293a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.789a.093.093,0,0,0,.1-.1v-.5a.088.088,0,0,0-.1-.1.088.088,0,0,0-.1.1v.4Zm1.046-.478h.567a.211.211,0,0,0,.159-.056.213.213,0,0,0,.063-.178v-.411a.213.213,0,0,0-.063-.178.211.211,0,0,0-.159-.056h-.664a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1h.686v.478h-.56a.2.2,0,0,0-.226.226v.652h.886a.093.093,0,0,0,.1-.1.091.091,0,0,0-.1-.1h-.69Zm2.028-.678h0v.334c0,.111-.041.144-.1.144h-.389a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.389c.059,0,.1.033.1.145v.334h-.686a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.686a.2.2,0,0,0,.2-.2v-.386a.228.228,0,0,0-.078-.193.229.229,0,0,0,.078-.193v-.386a.2.2,0,0,0-.2-.2h-.686a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1Zm2.391.649h0v-.749a.09.09,0,0,0-.1-.1.091.091,0,0,0-.1.1v.949h.586v.408a.088.088,0,0,0,.1.1c.074,0,.1-.037.1-.1v-.408a.093.093,0,0,0,.1-.1.091.091,0,0,0-.1-.1v-.579a.09.09,0,0,0-.1-.1.092.092,0,0,0-.1.1v.579Zm1.539-.649h.489a.093.093,0,0,0,.1-.1.093.093,0,0,0-.1-.1h-.689v.878h.589v.478h-.46a.377.377,0,0,1-.107-.041l-.059-.026a.132.132,0,0,0-.063-.015.1.1,0,0,0-.1.1c0,.07.059.085.115.111l.074.033a.3.3,0,0,0,.134.037h.441a.186.186,0,0,0,.174-.07.2.2,0,0,0,.048-.156v-.426a.2.2,0,0,0-.059-.171.214.214,0,0,0-.163-.056h-.367Zm1.242,0h0a.1.1,0,0,0,.1-.1.1.1,0,0,0-.093-.1h-.123c-.067,0-.085.056-.085.1v1.331c0,.093.037.126.13.126h.73c.089,0,.13-.033.13-.126v-.449c0-.093-.022-.133-.122-.133h-.667Zm.59.849h0v.308h-.59v-.308Zm1.438-.849h0v.274c0,.089,0,.089-.063.145l-.275.237c-.052.044-.052.052-.052.119v.482c0,.063.026.1.1.1a.088.088,0,0,0,.1-.1v-.389c0-.07,0-.074.056-.119l.278-.245c.059-.044.056-.056.056-.122v-.582h-.886a.1.1,0,0,0-.1.1v.1a.1.1,0,0,0,.1.1.1.1,0,0,0,.1-.1Z"
          transform="translate(-15.223 -231.268)"
          fill="#313133"
        />
        <path
          id="Path_5111"
          data-name="Path 5111"
          d="M-911.465,245.234v-1.353h-.5a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1h.3v1.153h-.3a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.787a.093.093,0,0,0,.1-.1v-.5a.088.088,0,0,0-.1-.1.088.088,0,0,0-.1.1v.4Zm1.042-.477h.562a.22.22,0,0,0,.163-.055.212.212,0,0,0,.059-.178v-.41a.211.211,0,0,0-.059-.177.22.22,0,0,0-.163-.055h-.662a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1h.684v.477h-.558a.2.2,0,0,0-.225.226v.65h.883a.093.093,0,0,0,.1-.1.091.091,0,0,0-.1-.1h-.684Zm2.022-.676h0v.333c0,.111-.044.144-.1.144h-.392a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.392c.056,0,.1.033.1.144v.333h-.688a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.688a.2.2,0,0,0,.2-.2v-.384a.239.239,0,0,0-.078-.192.239.239,0,0,0,.078-.192v-.384a.2.2,0,0,0-.2-.2h-.688a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1Zm.946.647h0v-.747a.091.091,0,0,0-.1-.1.093.093,0,0,0-.1.1v.946h.588v.406a.088.088,0,0,0,.1.1.088.088,0,0,0,.1-.1v-.406a.093.093,0,0,0,.1-.1.091.091,0,0,0-.1-.1v-.577a.089.089,0,0,0-.1-.1.091.091,0,0,0-.1.1v.577Zm2.971-.647H-904a.093.093,0,0,0,.1-.1.093.093,0,0,0-.1-.1h-.688v.876h.588v.477h-.462a.321.321,0,0,1-.1-.041l-.063-.026a.123.123,0,0,0-.063-.015.1.1,0,0,0-.1.1c0,.07.059.085.115.111l.074.033a.3.3,0,0,0,.133.037h.443a.192.192,0,0,0,.174-.07.211.211,0,0,0,.048-.155v-.425a.2.2,0,0,0-.063-.17.21.21,0,0,0-.159-.056h-.366Zm1.234,0h0a.1.1,0,0,0,.1-.1.1.1,0,0,0-.092-.1h-.118c-.07,0-.085.055-.085.1v1.327c0,.092.033.126.13.126h.724c.089,0,.13-.033.13-.126v-.447c0-.092-.019-.133-.119-.133h-.669Zm.588.846h0v.307h-.588v-.307Zm1.434-.846h0v.274c0,.089,0,.089-.059.144l-.277.237a.115.115,0,0,0-.051.118v.48a.088.088,0,0,0,.1.1c.074,0,.1-.037.1-.1v-.388c0-.07,0-.074.055-.118l.281-.244c.056-.044.052-.055.052-.122v-.58h-.883a.1.1,0,0,0-.1.1v.1a.1.1,0,0,0,.1.1.1.1,0,0,0,.1-.1Zm1.05.477h0v-.477h.188v.477Zm-.1-.676h0a.1.1,0,0,0-.1.1v.577a.2.2,0,0,0-.144.056.189.189,0,0,0-.055.144v.477a.186.186,0,0,0,.2.2h.588a.186.186,0,0,0,.2-.2v-.477a.189.189,0,0,0-.056-.144.21.21,0,0,0-.144-.056v-.577a.1.1,0,0,0-.1-.1Zm-.1,1.353h0v-.477h.588v.477Zm3.456,0h0a.1.1,0,0,0-.1.1.1.1,0,0,0,.1.1h.1a.1.1,0,0,0,.1-.1V243.98a.1.1,0,0,0-.1-.1h-.783a.1.1,0,0,0-.1.1v.51a.1.1,0,0,0,.1.1h.684Zm-.584-.843h0v-.31h.584v.31Zm1.826.843h0v-1.353h-.491a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1h.292v1.153h-.292a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.787a.093.093,0,0,0,.1-.1v-.5a.088.088,0,0,0-.1-.1.088.088,0,0,0-.1.1v.4Zm1.042-.477h.565a.21.21,0,0,0,.159-.055.213.213,0,0,0,.063-.178v-.41a.213.213,0,0,0-.063-.177.211.211,0,0,0-.159-.055h-.661a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1h.684v.477h-.558a.2.2,0,0,0-.226.226v.65h.884a.093.093,0,0,0,.1-.1.091.091,0,0,0-.1-.1h-.688Zm2.022-.676h0v.333c0,.111-.04.144-.1.144h-.388a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.388c.059,0,.1.033.1.144v.333h-.684a.091.091,0,0,0-.1.1.093.093,0,0,0,.1.1h.684a.194.194,0,0,0,.2-.2v-.384a.228.228,0,0,0-.078-.192.228.228,0,0,0,.078-.192v-.384a.194.194,0,0,0-.2-.2h-.684a.093.093,0,0,0-.1.1.093.093,0,0,0,.1.1Zm2.384.647h0v-.747a.09.09,0,0,0-.1-.1.091.091,0,0,0-.1.1v.946h.584v.406a.088.088,0,0,0,.1.1c.074,0,.1-.037.1-.1v-.406a.093.093,0,0,0,.1-.1.091.091,0,0,0-.1-.1v-.577a.089.089,0,0,0-.1-.1.091.091,0,0,0-.1.1v.577Zm1.534-.647h.488a.093.093,0,0,0,.1-.1.093.093,0,0,0-.1-.1h-.687v.876h.588v.477h-.458a.374.374,0,0,1-.107-.041l-.059-.026a.131.131,0,0,0-.063-.015.1.1,0,0,0-.1.1c0,.07.059.085.115.111l.074.033a.3.3,0,0,0,.133.037h.44a.186.186,0,0,0,.174-.07.2.2,0,0,0,.048-.155v-.425a.2.2,0,0,0-.059-.17.214.214,0,0,0-.162-.056h-.366Zm1.238,0h0a.1.1,0,0,0,.1-.1.1.1,0,0,0-.092-.1h-.122c-.067,0-.085.055-.085.1v1.327c0,.092.037.126.129.126h.728c.089,0,.129-.033.129-.126v-.447c0-.092-.022-.133-.122-.133h-.665Zm.588.846h0v.307h-.588v-.307Zm1.434-.846h0v.274c0,.089,0,.089-.062.144l-.274.237c-.052.044-.052.052-.052.118v.48c0,.063.026.1.1.1a.088.088,0,0,0,.1-.1v-.388c0-.07,0-.074.055-.118l.277-.244c.06-.044.056-.055.056-.122v-.58h-.883a.1.1,0,0,0-.1.1v.1a.1.1,0,0,0,.1.1.1.1,0,0,0,.1-.1Z"
          transform="translate(-15.222 -231.179)"
          fill="#fff"
        />
        <g
          id="Group_7621"
          data-name="Group 7621"
          transform="translate(-928.207 1.901)"
        >
          <g
            id="Group_7620"
            data-name="Group 7620"
            transform="translate(0 0)"
            clip-path="url(#clip-path-5)"
          >
            <rect
              id="Rectangle_1139"
              data-name="Rectangle 1139"
              width="2.07"
              height="2.19"
              transform="translate(-0.747 0.431) rotate(-30)"
              fill="url(#linear-gradient-2)"
            />
          </g>
        </g>
        <path
          id="Path_5113"
          data-name="Path 5113"
          d="M-917.763,161.6v-.4a.814.814,0,0,0-.512-.159.863.863,0,0,0-.882.862.863.863,0,0,0,.882.862.813.813,0,0,0,.512-.162v-.4a.771.771,0,0,1-.458.186.479.479,0,0,1-.51-.485.476.476,0,0,1,.51-.485.775.775,0,0,1,.458.184h0a.775.775,0,0,0-.458-.184.476.476,0,0,0-.51.485.479.479,0,0,0,.51.485.771.771,0,0,0,.458-.186v.4a.813.813,0,0,1-.512.162.863.863,0,0,1-.882-.862.863.863,0,0,1,.882-.862.814.814,0,0,1,.512.159v.4Z"
          transform="translate(-9.05 -159.142)"
          fill="url(#linear-gradient-3)"
        />
        <g
          id="Group_7623"
          data-name="Group 7623"
          transform="translate(-926.501 1.93)"
        >
          <g
            id="Group_7622"
            data-name="Group 7622"
            transform="translate(0 0)"
            clip-path="url(#clip-path-6)"
          >
            <rect
              id="Rectangle_1140"
              data-name="Rectangle 1140"
              width="1.186"
              height="1.651"
              transform="matrix(0.866, -0.5, 0.5, 0.866, -0.724, 0.418)"
              fill="url(#linear-gradient-4)"
            />
          </g>
        </g>
        <path
          id="Path_5114"
          data-name="Path 5114"
          d="M-906.072,162.94h.4v-1.673h-.4v1.673h0v-1.673h.4v1.673Z"
          transform="translate(-20.429 -159.337)"
          fill="url(#linear-gradient-5)"
        />
        <g
          id="Group_7625"
          data-name="Group 7625"
          transform="translate(-925.837 1.93)"
        >
          <g
            id="Group_7624"
            data-name="Group 7624"
            transform="translate(0 0)"
            clip-path="url(#clip-path-7)"
          >
            <rect
              id="Rectangle_1142"
              data-name="Rectangle 1142"
              width="1.991"
              height="2.115"
              transform="matrix(0.866, -0.5, 0.5, 0.866, -0.724, 0.418)"
              fill="url(#linear-gradient-6)"
            />
          </g>
        </g>
        <path
          id="Path_5116"
          data-name="Path 5116"
          d="M-899.647,161.643h0v-.377h-1.334v.377h.465v1.3h.4v-1.3h0v1.3h-.4v-1.3h-.465v-.377h1.334v.377Z"
          transform="translate(-24.857 -159.336)"
          fill="url(#linear-gradient-7)"
        />
        <g
          id="Group_7627"
          data-name="Group 7627"
          transform="translate(-924.4 1.922)"
        >
          <g
            id="Group_7626"
            data-name="Group 7626"
            transform="translate(0 0)"
            clip-path="url(#clip-path-8)"
          >
            <rect
              id="Rectangle_1143"
              data-name="Rectangle 1143"
              width="2.277"
              height="2.28"
              transform="translate(-0.724 0.418) rotate(-30)"
              fill="url(#linear-gradient-8)"
            />
          </g>
        </g>
        <path
          id="Path_5118"
          data-name="Path 5118"
          d="M-888.3,161.205h-.453l-.379.62-.379-.62h-.451l.631,1.033v.64h.4v-.64l.631-1.033h0l-.631,1.033v.64h-.4v-.64l-.631-1.033h.451l.379.62.379-.62Z"
          transform="translate(-34.441 -159.283)"
          fill="url(#linear-gradient-9)"
        />
        <g
          id="Group_7629"
          data-name="Group 7629"
          transform="translate(-921.994 1.922)"
        >
          <g
            id="Group_7628"
            data-name="Group 7628"
            transform="translate(0 0)"
            clip-path="url(#clip-path-9)"
          >
            <rect
              id="Rectangle_1144"
              data-name="Rectangle 1144"
              width="2.171"
              height="2.219"
              transform="translate(-0.724 0.418) rotate(-30)"
              fill="url(#linear-gradient-10)"
            />
          </g>
        </g>
        <path
          id="Path_5120"
          data-name="Path 5120"
          d="M-869.962,161.206h-.388l-.382.671-.388-.671h-.383v1.673h.393v-.963l.3.525h.146l.305-.525v.963h.394v-1.673h0v1.673h-.394v-.963l-.305.525h-.146l-.3-.525v.963h-.393v-1.673h.383l.388.671.382-.671Z"
          transform="translate(-50.491 -159.284)"
          fill="url(#linear-gradient-11)"
        />
        <g
          id="Group_7631"
          data-name="Group 7631"
          transform="translate(-920.27 1.922)"
        >
          <g
            id="Group_7630"
            data-name="Group 7630"
            transform="translate(0 0)"
            clip-path="url(#clip-path-10)"
          >
            <rect
              id="Rectangle_1145"
              data-name="Rectangle 1145"
              width="2.238"
              height="2.258"
              transform="matrix(0.866, -0.5, 0.5, 0.866, -0.724, 0.418)"
              fill="url(#linear-gradient-12)"
            />
          </g>
        </g>
        <path
          id="Path_5122"
          data-name="Path 5122"
          d="M-857.325,162.189h-.29l.144-.467.146.467h0l-.146-.467-.144.467Zm.137.375h0l.112.314h.416l-.6-1.673h-.411l-.6,1.673h.415l.112-.314h0l-.112.314h-.415l.6-1.673h.411l.6,1.673h-.416l-.112-.314Z"
          transform="translate(-61.991 -159.284)"
          fill="url(#linear-gradient-13)"
        />
        <g
          id="Group_7633"
          data-name="Group 7633"
          transform="translate(-918.486 1.922)"
        >
          <g
            id="Group_7632"
            data-name="Group 7632"
            transform="translate(0 0)"
            clip-path="url(#clip-path-11)"
          >
            <rect
              id="Rectangle_1146"
              data-name="Rectangle 1146"
              width="1.659"
              height="1.923"
              transform="translate(-0.724 0.418) rotate(-30)"
              fill="url(#linear-gradient-14)"
            />
          </g>
        </g>
        <path
          id="Path_5124"
          data-name="Path 5124"
          d="M-843.651,162.5h-.546v-1.3h-.4v1.673h.95V162.5h0v.377h-.95V161.2h.4v1.3Z"
          transform="translate(-73.885 -159.283)"
          fill="url(#linear-gradient-15)"
        />
        <g
          id="Group_7635"
          data-name="Group 7635"
          transform="translate(-917.342 1.922)"
        >
          <g
            id="Group_7634"
            data-name="Group 7634"
            transform="translate(0 0)"
            clip-path="url(#clip-path-12)"
          >
            <rect
              id="Rectangle_1147"
              data-name="Rectangle 1147"
              width="1.659"
              height="1.923"
              transform="matrix(0.866, -0.5, 0.5, 0.866, -0.724, 0.418)"
              fill="url(#linear-gradient-16)"
            />
          </g>
        </g>
        <path
          id="Path_5126"
          data-name="Path 5126"
          d="M-834.875,162.5h-.546v-1.3h-.4v1.673h.95V162.5h0v.377h-.95V161.2h.4v1.3Z"
          transform="translate(-81.518 -159.283)"
          fill="url(#linear-gradient-17)"
        />
        <g
          id="Group_7637"
          data-name="Group 7637"
          transform="translate(-928.207 4.567)"
        >
          <g
            id="Group_7636"
            data-name="Group 7636"
            transform="translate(0 0)"
            clip-path="url(#clip-path-13)"
          >
            <rect
              id="Rectangle_1148"
              data-name="Rectangle 1148"
              width="1.549"
              height="1.541"
              transform="matrix(0.5, -0.866, 0.866, 0.5, -0.495, 0.857)"
              fill="url(#linear-gradient-18)"
            />
          </g>
        </g>
        <path
          id="Path_5128"
          data-name="Path 5128"
          d="M-918.038,181.976h0a.823.823,0,0,1-.072.361.506.506,0,0,1-.2.224.574.574,0,0,1-.3.075.526.526,0,0,1-.281-.077.56.56,0,0,1-.2-.208.577.577,0,0,1-.073-.285.571.571,0,0,1,.074-.286.545.545,0,0,1,.207-.208.593.593,0,0,1,.3-.077.5.5,0,0,1,.243.059.6.6,0,0,1,.19.164l-.2.153a.324.324,0,0,0-.1-.089.258.258,0,0,0-.137-.036.326.326,0,0,0-.166.041.29.29,0,0,0-.112.115.341.341,0,0,0-.04.164.375.375,0,0,0,.035.164.272.272,0,0,0,.1.115.275.275,0,0,0,.151.042.32.32,0,0,0,.167-.042.255.255,0,0,0,.1-.118h-.341v-.25h0v.25h.341a.255.255,0,0,1-.1.118.32.32,0,0,1-.167.042.275.275,0,0,1-.151-.042.272.272,0,0,1-.1-.115.375.375,0,0,1-.035-.164.341.341,0,0,1,.04-.164.29.29,0,0,1,.112-.115.326.326,0,0,1,.166-.041.258.258,0,0,1,.137.036.324.324,0,0,1,.1.089l.2-.153a.6.6,0,0,0-.19-.164.5.5,0,0,0-.243-.059.593.593,0,0,0-.3.077.545.545,0,0,0-.207.208.571.571,0,0,0-.074.286.577.577,0,0,0,.073.285.56.56,0,0,0,.2.208.526.526,0,0,0,.281.077.574.574,0,0,0,.3-.075.506.506,0,0,0,.2-.224.823.823,0,0,0,.072-.361Z"
          transform="translate(-9.049 -176.927)"
          fill="url(#linear-gradient-19)"
        />
        <g
          id="Group_7639"
          data-name="Group 7639"
          transform="translate(-926.97 4.583)"
        >
          <g
            id="Group_7638"
            data-name="Group 7638"
            transform="translate(0)"
            clip-path="url(#clip-path-14)"
          >
            <rect
              id="Rectangle_1149"
              data-name="Rectangle 1149"
              width="1.095"
              height="0.786"
              transform="matrix(0.5, -0.866, 0.866, 0.5, -0.481, 0.833)"
              fill="url(#linear-gradient-20)"
            />
          </g>
        </g>
        <path
          id="Path_5129"
          data-name="Path 5129"
          d="M-909.666,181.613h.266v1.111h-.266v-1.111h0v1.111h.266v-1.111Z"
          transform="translate(-17.304 -177.03)"
          fill="url(#linear-gradient-21)"
        />
        <g
          id="Group_7641"
          data-name="Group 7641"
          transform="translate(-926.571 4.583)"
        >
          <g
            id="Group_7640"
            data-name="Group 7640"
            transform="translate(0 0)"
            clip-path="url(#clip-path-15)"
          >
            <rect
              id="Rectangle_1151"
              data-name="Rectangle 1151"
              width="1.291"
              height="1.125"
              transform="translate(-0.481 0.833) rotate(-60)"
              fill="url(#linear-gradient-22)"
            />
          </g>
        </g>
        <path
          id="Path_5131"
          data-name="Path 5131"
          d="M-905.949,181.864h-.391v.194H-906v.25h-.344v.416h-.266v-1.111h.657v.25h0v-.25h-.657v1.111h.266v-.416H-906v-.25h-.344v-.194Z"
          transform="translate(-19.965 -177.031)"
          fill="url(#linear-gradient-23)"
        />
        <g
          id="Group_7643"
          data-name="Group 7643"
          transform="translate(-925.781 4.583)"
        >
          <g
            id="Group_7642"
            data-name="Group 7642"
            transform="translate(0 0)"
            clip-path="url(#clip-path-16)"
          >
            <rect
              id="Rectangle_1152"
              data-name="Rectangle 1152"
              width="1.345"
              height="1.219"
              transform="matrix(0.5, -0.866, 0.866, 0.5, -0.481, 0.833)"
              fill="url(#linear-gradient-24)"
            />
          </g>
        </g>
        <path
          id="Path_5133"
          data-name="Path 5133"
          d="M-899.78,181.614h0v.25h-.25v.861h-.266v-.861h-.25v-.25h0v.25h.25v.861h.266v-.861h.25v-.25Z"
          transform="translate(-25.234 -177.031)"
          fill="url(#linear-gradient-25)"
        />
        <g
          id="Group_7645"
          data-name="Group 7645"
          transform="translate(-924.632 4.583)"
        >
          <g
            id="Group_7644"
            data-name="Group 7644"
            transform="translate(0)"
            clip-path="url(#clip-path-17)"
          >
            <rect
              id="Rectangle_1153"
              data-name="Rectangle 1153"
              width="1.43"
              height="1.334"
              transform="translate(-0.495 0.857) rotate(-60)"
              fill="url(#linear-gradient-26)"
            />
          </g>
        </g>
        <path
          id="Path_5135"
          data-name="Path 5135"
          d="M-890.853,181.986h0a.284.284,0,0,0-.052-.048.373.373,0,0,0-.1-.052.4.4,0,0,0-.138-.023.347.347,0,0,0-.163.039.3.3,0,0,0-.119.112.322.322,0,0,0-.044.17.322.322,0,0,0,.044.17.3.3,0,0,0,.119.112.347.347,0,0,0,.163.039.4.4,0,0,0,.138-.023.368.368,0,0,0,.1-.052.285.285,0,0,0,.052-.048v.266a.565.565,0,0,1-.126.072.5.5,0,0,1-.2.034.549.549,0,0,1-.28-.074.541.541,0,0,1-.2-.206.581.581,0,0,1-.074-.291.581.581,0,0,1,.074-.291.541.541,0,0,1,.2-.206.549.549,0,0,1,.28-.074.5.5,0,0,1,.2.034.564.564,0,0,1,.126.072v.266h0v-.266a.564.564,0,0,0-.126-.072.5.5,0,0,0-.2-.034.549.549,0,0,0-.28.074.541.541,0,0,0-.2.206.581.581,0,0,0-.074.291.581.581,0,0,0,.074.291.541.541,0,0,0,.2.206.549.549,0,0,0,.28.074.5.5,0,0,0,.2-.034.565.565,0,0,0,.126-.072v-.266a.285.285,0,0,1-.052.048.368.368,0,0,1-.1.052.4.4,0,0,1-.138.023.347.347,0,0,1-.163-.039.3.3,0,0,1-.119-.112.322.322,0,0,1-.044-.17.322.322,0,0,1,.044-.17.3.3,0,0,1,.119-.112.347.347,0,0,1,.163-.039.4.4,0,0,1,.138.023.373.373,0,0,1,.1.052.284.284,0,0,1,.052.048Z"
          transform="translate(-32.898 -177.031)"
          fill="url(#linear-gradient-27)"
        />
        <g
          id="Group_7647"
          data-name="Group 7647"
          transform="translate(-923.68 4.599)"
        >
          <g
            id="Group_7646"
            data-name="Group 7646"
            transform="translate(0 0)"
            clip-path="url(#clip-path-18)"
          >
            <rect
              id="Rectangle_1154"
              data-name="Rectangle 1154"
              width="1.514"
              height="1.512"
              transform="translate(-0.481 0.833) rotate(-60)"
              fill="url(#linear-gradient-28)"
            />
          </g>
        </g>
        <path
          id="Path_5137"
          data-name="Path 5137"
          d="M-883.61,182.845h0l-.075-.208h-.4l-.075.208h-.276l.4-1.111h.3l.4,1.111h0l-.4-1.111h-.3l-.4,1.111h.276l.075-.208h.4l.075.208Zm-.388-.459h.222l-.111-.31-.111.31h0l.111-.31.111.31Z"
          transform="translate(-39.241 -177.135)"
          fill="url(#linear-gradient-29)"
        />
        <g
          id="Group_7649"
          data-name="Group 7649"
          transform="translate(-922.49 4.599)"
        >
          <g
            id="Group_7648"
            data-name="Group 7648"
            transform="translate(0 0)"
            clip-path="url(#clip-path-19)"
          >
            <rect
              id="Rectangle_1155"
              data-name="Rectangle 1155"
              width="1.402"
              height="1.318"
              transform="translate(-0.481 0.833) rotate(-60)"
              fill="url(#linear-gradient-30)"
            />
          </g>
        </g>
        <g
          id="Group_7651"
          data-name="Group 7651"
          transform="translate(-921.46 4.599)"
        >
          <g
            id="Group_7650"
            data-name="Group 7650"
            transform="translate(0 0)"
            clip-path="url(#clip-path-20)"
          >
            <rect
              id="Rectangle_1156"
              data-name="Rectangle 1156"
              width="1.44"
              height="1.383"
              transform="translate(-0.481 0.833) rotate(-60)"
              fill="url(#linear-gradient-31)"
            />
          </g>
        </g>
      </g>
    </svg>

    <svg
      v-if="name == 'long-logo-footer'"
      xmlns="http://www.w3.org/2000/svg"
      width="1888.902"
      height="35.846"
      viewBox="0 0 1888.902 35.846"
    >
      <g
        id="Group_6373"
        data-name="Group 6373"
        transform="translate(481.439 948.341)"
        opacity="0.1"
      >
        <path
          id="Path_2790"
          data-name="Path 2790"
          d="M-341.362-913.076v-9.439h25.231v-25.23h9.439v34.669Zm18.281-16.388v-18.3h-8.972v9.323h-9.323v8.973Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2791"
          data-name="Path 2791"
          d="M-387.913-944.491l31.2,31.2h-31.2v-.03l9.991-10.139-9.991-9.991Zm34.254,28.145v-31.2h-.03l-10.139,9.991-9.991-9.991h-11.039Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2792"
          data-name="Path 2792"
          d="M-407.659-920.535v-27h7.253v34.254H-434.66v-7.253Zm-27.008-23.75v18.724h18.724Zm21.982,15.466v-18.736h-18.736Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2793"
          data-name="Path 2793"
          d="M-447.137-920.444V-940.37a7.2,7.2,0,0,0-7.2-7.2,7.2,7.2,0,0,0-7.2,7.2v2.115l-5.6-5.6a7.486,7.486,0,0,0-10.588,0,7.467,7.467,0,0,0-2.193,5.295,7.463,7.463,0,0,0,2.193,5.294l5.6,5.6h-2.116a7.2,7.2,0,0,0-7.2,7.2,7.2,7.2,0,0,0,7.2,7.2h19.919a7.2,7.2,0,0,0,7.184-7.177"
          fill="#1a1a1a"
        />
        <path
          id="Path_2794"
          data-name="Path 2794"
          d="M-259.939-924.891c0,7.216-6.244,12.4-13.876,12.4-6.938,0-13.274-4.533-13.274-12.442V-947.6h8.325v21.138c0,4.255,2.22,6.105,4.949,6.105a4.966,4.966,0,0,0,5.088-5.135c0-5.6-3.33-8.741-3.238-14.292h8.7c0,4.95,3.33,8.7,3.33,14.894"
          fill="#1a1a1a"
        />
        <path
          id="Path_2795"
          data-name="Path 2795"
          d="M-236.627-913.189v-21.138c0-8.233-10.361-8.233-10.361,0v21.138h-8.326v-20.027c0-8.372,4.487-15.125,13.506-15.125s13.506,6.753,13.506,15.125v20.027Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2796"
          data-name="Path 2796"
          d="M-207.766-935.807c0-6.244-7.585-6.244-7.585,0V-924.8c0,6.106,7.585,6.106,7.585,0Zm12.951-12.441c6.522,0,10.685,4.625,10.685,11.146v23.914h-8.326v-23.127c0-5.55-6.984-5.55-6.984,0v10.083c0,7.956-4.625,13.737-12.119,13.737-7.446,0-12.118-5.643-12.118-13.737v-8.557c0-7.909,4.626-13.552,12.118-13.552a11.713,11.713,0,0,1,8.743,4.394,10.442,10.442,0,0,1,8-4.3"
          fill="#1a1a1a"
        />
        <path
          id="Path_2797"
          data-name="Path 2797"
          d="M-160.819-913.189v-21.138c0-8.233-10.361-8.233-10.361,0v21.138h-8.326v-20.027c0-8.372,4.487-15.125,13.506-15.125s13.507,6.753,13.507,15.125v20.027Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2798"
          data-name="Path 2798"
          d="M-118.4-933.24v-2.266c0-3.284-1.943-5.088-5.689-5.088-4.255,0-8.7,2.312-11.471,4.163v-7.863a24.037,24.037,0,0,1,12.118-4.024c8.048,0,13.367,4.81,13.367,13.275v9.667c0,8.094-6.429,12.858-13.274,12.858-6.938,0-13.876-4.3-13.876-12.072,0-7.632,5.5-12.165,11.748-12.165a8.836,8.836,0,0,1,7.031,3.561Zm-10.037,8.6a4.924,4.924,0,0,0,5,5.134,5.045,5.045,0,0,0,5.042-5.134,4.959,4.959,0,0,0-5.042-5.227c-3.145,0-5,2.127-5,5.227"
          fill="#1a1a1a"
        />
        <path
          id="Path_2799"
          data-name="Path 2799"
          d="M-76.592-948.318c-3.26,0-6.5,2.063-8.953,5.117-2.355-3.054-5.5-5.117-8.808-5.117-6.753,0-11.1,4.9-11.1,12.858v22.294h8.326v-22.8c0-6.014,7.307-6.014,7.307,0v14.014H-81.5v-14.014c0-6.014,7.262-6.014,7.262,0v22.8h8.326V-935.46c0-7.956-3.932-12.858-10.685-12.858"
          fill="#1a1a1a"
        />
        <path
          id="Path_2800"
          data-name="Path 2800"
          d="M-61.792-935.136c0-7.678,5.967-13.182,13.922-13.182,6.8,0,13.506,4.255,13.506,12.164,0,2.914-.971,5.921-.971,8.881h-8.6c0-2.729.878-5.967.878-8.233,0-3.33-2.219-5.365-5.041-5.365s-4.9,2.081-4.9,5.6c0,3.423,1.11,6.152,6.059,9.852,4.9,3.7,9.436,7.817,9.436,12.258h-8.927c0-2.73-1.9-3.516-6.244-3.516H-59.8v-5.92h5.134c-4.348-3.238-7.123-7.308-7.123-12.535"
          fill="#1a1a1a"
        />
        <path
          id="Path_2801"
          data-name="Path 2801"
          d="M-11.561-913.165V-934.3c0-8.233-10.361-8.233-10.361,0v21.138h-8.325v-20.028c0-8.371,4.486-15.124,13.506-15.124s13.506,6.753,13.506,15.124v20.028Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2802"
          data-name="Path 2802"
          d="M152.18-913.457v-34.051h34.077v3.168H155.348v30.883Zm8.783.129v-25.4h25.421v-3.167H157.795v28.563Zm25.194-6.666-13.115-13.117h13.215v-3.167H165.394l18.523,18.523Zm-6.438,6.438,2.24-2.24L163.435-934.32v20.863H166.6v-13.215Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2803"
          data-name="Path 2803"
          d="M64.012-941.6h4.413v10.9h9.742v9.743h8.877v7.87h5.472v-13.342H83.638v-9.741H73.9v-5.43H92.525v-6.157H57.856v34.67h6.156Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2804"
          data-name="Path 2804"
          d="M138.115-922.8h0l-12.569-12.568h12.569v-12.171H103.861v34.254h12.17v-12.568L128.6-913.291h9.516ZM114.3-915.019h-3.49v-25.576l3.49,3.49Zm10.04-12.047v7.072l-3.364-3.364v-7.072Zm-18.752-18.752,3.494,3.494v27.3h-3.494Zm10.44,17.512v-7.071l3.22,3.219v7.073l-2-2Zm10.04,10.04v-7.071l3.364,3.363v6.955h-.117Zm5.092,3.247v-5.227l5.227,5.227Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2805"
          data-name="Path 2805"
          d="M11.934-915.268v-30.379a1.983,1.983,0,0,1,1.9-1.9H44.184a2,2,0,0,1,2,2,2,2,0,0,1-.585,1.414L33.891-932.42a2,2,0,0,1-1.415.586,2,2,0,0,1-2-2v-4.536a2,2,0,0,0-.586-1.4,2,2,0,0,0-2.83,0l-7.365,7.364a2,2,0,0,0,.011,2.819,2,2,0,0,0,1.412.586H44.479a2,2,0,0,1,1.729,1.98,1.993,1.993,0,0,1-.564,1.391L33.866-913.855a1.989,1.989,0,0,1-1.39.564,2,2,0,0,1-2-1.994v-8.887l0,0a2,2,0,0,0-.586-1.415,2,2,0,0,0-2.829,0L15.35-913.878h0a2,2,0,0,1-1.416.587,2,2,0,0,1-2-1.976"
          fill="#1a1a1a"
        />
        <path
          id="Path_2806"
          data-name="Path 2806"
          d="M228.838-936.543v-8.183a16.59,16.59,0,0,0-10.423-3.246,17.567,17.567,0,0,0-17.965,17.554c0,9.828,7.863,17.554,17.965,17.554a16.571,16.571,0,0,0,10.423-3.291v-8.183c-2.438,1.962-5.852,3.794-9.326,3.794-5.851,0-10.377-3.932-10.377-9.874,0-5.806,4.252-9.874,10.377-9.874,3.566,0,6.742,1.781,9.326,3.749"
          fill="#1a1a1a"
        />
        <rect
          id="Rectangle_833"
          data-name="Rectangle 833"
          width="8.229"
          height="34.056"
          transform="translate(235.375 -947.378)"
          fill="#1a1a1a"
        />
        <path
          id="Path_2807"
          data-name="Path 2807"
          d="M276.258-939.7v-7.68H249.1v7.68h9.463v26.376h8.183V-939.7Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2808"
          data-name="Path 2808"
          d="M312.234-947.377H303l-7.725,12.616-7.726-12.616H278.36l12.846,21.027v13.029h8.183V-926.35Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2809"
          data-name="Path 2809"
          d="M388.567-927.356h-5.9l2.926-9.508Zm2.789,7.635,2.286,6.4H402.1l-12.3-34.055h-8.365l-12.3,34.055H377.6l2.285-6.4Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2810"
          data-name="Path 2810"
          d="M428.734-921H416.406v-26.376h-8.838v34.056h21.166Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2811"
          data-name="Path 2811"
          d="M455.979-921H443.652v-26.376h-8.838v34.056h21.165Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2812"
          data-name="Path 2812"
          d="M364.676-947.377h-7.908l-7.787,13.668-7.893-13.668h-7.8v34.056H341.3v-19.611l.624.972,5.547,9.709h2.972l5.753-9.884.464-.8v19.611h8.015Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2813"
          data-name="Path 2813"
          d="M610.122-913.076v-9.439h25.231v-25.23h9.438v34.669ZM628.4-929.464v-18.3h-8.972v9.323h-9.324v8.973Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2814"
          data-name="Path 2814"
          d="M563.572-944.491l31.2,31.2h-31.2v-.03l9.99-10.139-9.99-9.991Zm34.253,28.145v-31.2H597.8l-10.14,9.991-9.991-9.991H566.626Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2815"
          data-name="Path 2815"
          d="M543.825-920.535v-27h7.253v34.254H516.824v-7.253Zm-27.008-23.75v18.724h18.724ZM538.8-928.819v-18.736H520.063Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2816"
          data-name="Path 2816"
          d="M504.347-920.444V-940.37a7.2,7.2,0,0,0-7.2-7.2,7.2,7.2,0,0,0-7.2,7.2v2.115l-5.6-5.6a7.486,7.486,0,0,0-10.588,0,7.467,7.467,0,0,0-2.193,5.295,7.463,7.463,0,0,0,2.193,5.294l5.6,5.6h-2.115a7.2,7.2,0,0,0-7.2,7.2,7.2,7.2,0,0,0,7.2,7.2h19.919a7.2,7.2,0,0,0,7.183-7.177"
          fill="#1a1a1a"
        />
        <path
          id="Path_2817"
          data-name="Path 2817"
          d="M691.545-924.891c0,7.216-6.244,12.4-13.876,12.4-6.938,0-13.274-4.533-13.274-12.442V-947.6h8.325v21.138c0,4.255,2.22,6.105,4.949,6.105a4.966,4.966,0,0,0,5.088-5.135c0-5.6-3.33-8.741-3.238-14.292h8.7c0,4.95,3.33,8.7,3.33,14.894"
          fill="#1a1a1a"
        />
        <path
          id="Path_2818"
          data-name="Path 2818"
          d="M714.856-913.189v-21.138c0-8.233-10.361-8.233-10.361,0v21.138H696.17v-20.027c0-8.372,4.486-15.125,13.506-15.125s13.506,6.753,13.506,15.125v20.027Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2819"
          data-name="Path 2819"
          d="M743.718-935.807c0-6.244-7.585-6.244-7.585,0V-924.8c0,6.106,7.585,6.106,7.585,0Zm12.951-12.441c6.522,0,10.685,4.625,10.685,11.146v23.914h-8.326v-23.127c0-5.55-6.984-5.55-6.984,0v10.083c0,7.956-4.625,13.737-12.118,13.737-7.447,0-12.119-5.643-12.119-13.737v-8.557c0-7.909,4.626-13.552,12.119-13.552a11.711,11.711,0,0,1,8.742,4.394,10.442,10.442,0,0,1,8-4.3"
          fill="#1a1a1a"
        />
        <path
          id="Path_2820"
          data-name="Path 2820"
          d="M790.665-913.189v-21.138c0-8.233-10.361-8.233-10.361,0v21.138h-8.325v-20.027c0-8.372,4.486-15.125,13.506-15.125s13.506,6.753,13.506,15.125v20.027Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2821"
          data-name="Path 2821"
          d="M833.079-933.24v-2.266c0-3.284-1.943-5.088-5.689-5.088-4.255,0-8.7,2.312-11.471,4.163v-7.863a24.041,24.041,0,0,1,12.119-4.024c8.047,0,13.367,4.81,13.367,13.275v9.667c0,8.094-6.429,12.858-13.275,12.858-6.938,0-13.876-4.3-13.876-12.072,0-7.632,5.5-12.165,11.748-12.165a8.836,8.836,0,0,1,7.031,3.561Zm-10.037,8.6a4.924,4.924,0,0,0,5,5.134,5.044,5.044,0,0,0,5.041-5.134,4.958,4.958,0,0,0-5.041-5.227c-3.146,0-5,2.127-5,5.227"
          fill="#1a1a1a"
        />
        <path
          id="Path_2822"
          data-name="Path 2822"
          d="M874.892-948.318c-3.26,0-6.5,2.063-8.952,5.117-2.357-3.054-5.505-5.117-8.81-5.117-6.752,0-11.1,4.9-11.1,12.858v22.294h8.327v-22.8c0-6.014,7.308-6.014,7.308,0v14.014h8.324v-14.014c0-6.014,7.262-6.014,7.262,0v22.8h8.326V-935.46c0-7.956-3.932-12.858-10.684-12.858"
          fill="#1a1a1a"
        />
        <path
          id="Path_2823"
          data-name="Path 2823"
          d="M889.693-935.136c0-7.678,5.966-13.182,13.922-13.182,6.8,0,13.506,4.255,13.506,12.164,0,2.914-.971,5.921-.971,8.881h-8.6c0-2.729.878-5.967.878-8.233,0-3.33-2.22-5.365-5.041-5.365s-4.9,2.081-4.9,5.6c0,3.423,1.11,6.152,6.059,9.852,4.9,3.7,9.436,7.817,9.436,12.258h-8.927c0-2.73-1.9-3.516-6.244-3.516h-7.123v-5.92h5.134c-4.348-3.238-7.123-7.308-7.123-12.535"
          fill="#1a1a1a"
        />
        <path
          id="Path_2824"
          data-name="Path 2824"
          d="M939.923-913.165V-934.3c0-8.233-10.36-8.233-10.36,0v21.138h-8.326v-20.028c0-8.371,4.486-15.124,13.506-15.124s13.506,6.753,13.506,15.124v20.028Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2825"
          data-name="Path 2825"
          d="M1103.664-913.457v-34.051h34.077v3.168h-30.909v30.883Zm8.783.129v-25.4h25.421v-3.167h-28.589v28.563Zm25.194-6.666-13.115-13.117h13.215v-3.167h-20.863l18.524,18.523Zm-6.438,6.438,2.24-2.24L1114.92-934.32v20.863h3.168v-13.215Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2826"
          data-name="Path 2826"
          d="M1015.5-941.6h4.413v10.9h9.742v9.743h8.878v7.87H1044v-13.342h-8.878v-9.741h-9.742v-5.43h18.629v-6.157H1009.34v34.67h6.156Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2827"
          data-name="Path 2827"
          d="M1089.6-922.8h0l-12.569-12.568H1089.6v-12.171h-34.254v34.254h12.17v-12.568l12.568,12.568h9.516Zm-23.814,7.786h-3.491v-25.576l3.491,3.49Zm10.039-12.047v7.072l-3.364-3.364v-7.072Zm-18.752-18.752,3.495,3.494v27.3h-3.495Zm10.44,17.512v-7.071l3.22,3.219v7.073l-1.995-2Zm10.04,10.04v-7.071l3.364,3.363v6.955h-.117Zm5.092,3.247v-5.227l5.227,5.227Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2828"
          data-name="Path 2828"
          d="M963.418-915.268v-30.379a1.984,1.984,0,0,1,1.9-1.9h30.347a2,2,0,0,1,2,2,2,2,0,0,1-.585,1.414L985.375-932.42a2,2,0,0,1-1.415.586,2,2,0,0,1-2-2v-4.536a1.993,1.993,0,0,0-.586-1.4,2,2,0,0,0-2.83,0l-7.365,7.364a2,2,0,0,0,.011,2.819A2,2,0,0,0,972.6-929h23.363a2,2,0,0,1,1.728,1.98,1.993,1.993,0,0,1-.564,1.391l-11.777,11.778a1.993,1.993,0,0,1-1.391.564,2,2,0,0,1-2-1.994v-8.887l0,0a2,2,0,0,0-.586-1.415,2,2,0,0,0-2.829,0l-11.706,11.707h0a2,2,0,0,1-1.416.587,2,2,0,0,1-2-1.976"
          fill="#1a1a1a"
        />
        <path
          id="Path_2829"
          data-name="Path 2829"
          d="M1180.322-936.543v-8.183a16.587,16.587,0,0,0-10.422-3.246,17.567,17.567,0,0,0-17.966,17.554c0,9.828,7.863,17.554,17.966,17.554a16.568,16.568,0,0,0,10.422-3.291v-8.183c-2.438,1.962-5.851,3.794-9.325,3.794-5.852,0-10.377-3.932-10.377-9.874,0-5.806,4.251-9.874,10.377-9.874,3.565,0,6.741,1.781,9.325,3.749"
          fill="#1a1a1a"
        />
        <rect
          id="Rectangle_834"
          data-name="Rectangle 834"
          width="8.228"
          height="34.056"
          transform="translate(1186.86 -947.378)"
          fill="#1a1a1a"
        />
        <path
          id="Path_2830"
          data-name="Path 2830"
          d="M1227.742-939.7v-7.68h-27.154v7.68h9.463v26.376h8.183V-939.7Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2831"
          data-name="Path 2831"
          d="M1263.718-947.377h-9.234l-7.725,12.616-7.726-12.616h-9.188l12.845,21.027v13.029h8.183V-926.35Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2832"
          data-name="Path 2832"
          d="M1340.051-927.356h-5.9l2.926-9.508Zm2.789,7.635,2.286,6.4h8.457l-12.3-34.055h-8.366l-12.3,34.055h8.457l2.286-6.4Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2833"
          data-name="Path 2833"
          d="M1380.218-921h-12.327v-26.376h-8.838v34.056h21.165Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2834"
          data-name="Path 2834"
          d="M1407.463-921h-12.328v-26.376H1386.3v34.056h21.166Z"
          fill="#1a1a1a"
        />
        <path
          id="Path_2835"
          data-name="Path 2835"
          d="M1316.16-947.377h-7.908l-7.787,13.668-7.893-13.668h-7.8v34.056h8.015v-19.611l.624.972,5.548,9.709h2.971l5.753-9.884.464-.8v19.611h8.015Z"
          fill="#1a1a1a"
        />
      </g>
    </svg>

    <svg
      v-if="name == 'long-logo'"
      xmlns="http://www.w3.org/2000/svg"
      width="3706.559"
      height="70.328"
      viewBox="0 0 3706.559 70.328"
    >
      <g
        id="Group_1810"
        data-name="Group 1810"
        transform="translate(-13.94 -3273.983)"
        opacity="0.09"
      >
        <path
          id="Path_627"
          data-name="Path 627"
          d="M154.539,84.232V65.708h49.508V16.2h18.524V84.232ZM190.41,52.07V16.18H172.749V34.468H154.5V52.129Z"
          transform="translate(134.278 3258.941)"
          fill="#fff"
        />
        <path
          id="Path_628"
          data-name="Path 628"
          d="M108,22.395l61.223,61.223H108l19.623-19.9L108,44.1Zm67.208,55.219V16.39h0l-19.9,19.623L135.688,16.39h-21.8Z"
          transform="translate(89.531 3259.143)"
          fill="#fff"
        />
        <path
          id="Path_629"
          data-name="Path 629"
          d="M114.2,69.4V16.419h14.227V83.627H61.22V69.4ZM61.22,22.8V59.55H97.954Zm43.17,30.357V16.38H67.578Z"
          transform="translate(44.516 3259.133)"
          fill="#fff"
        />
        <path
          id="Path_630"
          data-name="Path 630"
          d="M81.746,69.587V30.5a14.128,14.128,0,0,0-28.257,0v4.14L42.5,23.65A14.7,14.7,0,0,0,21.74,44.431L32.728,55.419h-4.16a14.128,14.128,0,1,0,0,28.257H67.657A14.128,14.128,0,0,0,81.746,69.587"
          transform="translate(-0.5 3259.124)"
          fill="#fff"
        />
        <path
          id="Path_631"
          data-name="Path 631"
          d="M262.066,60.805c0,14.168-12.245,24.332-27.237,24.332-13.618,0-26.04-8.889-26.04-24.411V16.34h16.326V57.8c0,8.359,4.356,11.97,9.713,11.97a9.811,9.811,0,0,0,9.988-10.086c0-10.989-6.534-17.15-6.358-28.041h17.072c0,9.811,6.534,17.072,6.534,29.218"
          transform="translate(186.52 3259.095)"
          fill="#fff"
        />
        <path
          id="Path_632"
          data-name="Path 632"
          d="M277.235,84.545V43.063c0-16.15-20.329-16.15-20.329,0V84.545H240.56V45.3c0-16.424,8.811-29.67,26.51-29.67s26.51,13.245,26.51,29.689V84.565Z"
          transform="translate(217.092 3258.412)"
          fill="#fff"
        />
        <path
          id="Path_633"
          data-name="Path 633"
          d="M303.42,40.187c0-12.245-14.874-12.245-14.874,0V61.773c0,11.99,14.874,11.99,14.874,0Zm25.51-24.411c12.794,0,20.957,9.066,20.957,21.879V84.574H333.541V39.187c0-10.891-13.736-10.891-13.736,0v19.78c0,15.7-9.066,26.962-23.783,26.962S272.2,74.861,272.2,58.966V42.189c0-15.522,9.085-26.589,23.783-26.589a22.978,22.978,0,0,1,17.15,8.634,20.486,20.486,0,0,1,15.7-8.438"
          transform="translate(247.538 3258.383)"
          fill="#fff"
        />
        <path
          id="Path_634"
          data-name="Path 634"
          d="M353.045,84.545V43.063c0-16.15-20.329-16.15-20.329,0V84.545H316.37V45.3c0-16.424,8.811-29.67,26.51-29.67s26.51,13.245,26.51,29.689V84.565Z"
          transform="translate(290.043 3258.412)"
          fill="#fff"
        />
        <path
          id="Path_635"
          data-name="Path 635"
          d="M395.58,45.192V40.738c0-6.436-3.807-9.988-11.165-9.988-8.359,0-17.072,4.533-22.507,8.163V23.489A47.1,47.1,0,0,1,385.69,15.64c15.7,0,26.236,9.439,26.236,26.04V60.655c0,15.875-12.617,25.235-26.039,25.235S358.65,77.452,358.65,62.205s10.793-23.861,23.057-23.861a17.347,17.347,0,0,1,13.736,6.986ZM375.957,62.068a9.655,9.655,0,0,0,9.811,10.067,9.811,9.811,0,0,0,9.811-10.067A9.811,9.811,0,0,0,385.769,51.8c-6.181,0-9.811,4.18-9.811,10.263"
          transform="translate(330.728 3258.421)"
          fill="#fff"
        />
        <path
          id="Path_636"
          data-name="Path 636"
          d="M447.11,15.62c-6.4,0-12.755,4.042-17.661,10.047-4.631-5.985-10.793-10.047-17.288-10.047-13.245,0-21.781,9.615-21.781,25.235V84.594h16.346V39.913c0-11.774,14.344-11.774,14.344,0V67.385h16.346V39.913c0-11.774,14.246-11.774,14.246,0v44.74h16.464v-43.8c0-15.7-7.712-25.235-20.957-25.235"
          transform="translate(361.261 3258.402)"
          fill="#fff"
        />
        <path
          id="Path_637"
          data-name="Path 637"
          d="M434.09,41.483c0-15.07,11.774-25.863,27.315-25.863,13.344,0,26.51,8.359,26.51,23.861,0,5.71-1.962,11.617-1.962,17.425H469.078c0-5.357,1.727-11.774,1.727-16.15,0-6.534-4.356-10.518-9.811-10.518s-9.615,4.082-9.615,10.989,2.178,12.068,11.891,19.329S481.793,75.9,481.793,84.614H464.27c0-5.357-3.728-6.907-12.245-6.907H438.054V66.09H448.12c-8.536-6.358-13.971-14.344-13.971-24.607"
          transform="translate(403.323 3258.402)"
          fill="#fff"
        />
        <path
          id="Path_638"
          data-name="Path 638"
          d="M502.3,84.565V43.083c0-16.15-20.329-16.15-20.329,0V84.565H465.64V45.32c0-16.424,8.811-29.67,26.51-29.67s26.51,13.245,26.51,29.67V84.565Z"
          transform="translate(433.683 3258.431)"
          fill="#fff"
        />
        <path
          id="Path_639"
          data-name="Path 639"
          d="M648.06,83.246V16.43h66.875v6.22H654.28v60.6Zm17.229.255V33.659H715.17v-6.3h-56.1V83.5ZM714.66,70.412,688.993,44.687h25.922v-6.22H673.982l36.361,36.342ZM702.023,83.05l4.4-4.4L670.136,42.313V83.246h6.22V57.3Z"
          transform="translate(609.223 3259.181)"
          fill="#fff"
        />
        <path
          id="Path_640"
          data-name="Path 640"
          d="M565.808,28.268h8.654V49.657h19.132V68.769H611V84.212h10.753V58.036H604.328V38.923H585.215V28.268h36.538V16.18H553.74V84.212h12.068Z"
          transform="translate(518.46 3258.941)"
          fill="#fff"
        />
        <path
          id="Path_641"
          data-name="Path 641"
          d="M666.968,64.937h0L642.3,40.271h24.666V16.39H599.74V83.618h23.881V58.952l24.666,24.666h18.681ZM620.226,80.223h-6.848v-50.2l6.848,6.848Zm19.623-23.547V70.549l-6.593-6.593V49.984ZM603.135,19.785l6.927,6.848V80.2h-6.848Zm20.486,34.36V40.271l6.318,6.319V60.463l-3.925-3.925Zm19.623,19.623V59.972l6.672,6.672V80.38h-.235Zm9.988,6.456V69.96l10.263,10.263Z"
          transform="translate(562.725 3259.143)"
          fill="#fff"
        />
        <path
          id="Path_642"
          data-name="Path 642"
          d="M507.81,79.733V20.118a3.925,3.925,0,0,1,3.728-3.728h59.555A3.925,3.925,0,0,1,573.88,23.1L550.9,46.079a3.925,3.925,0,0,1-6.711-2.786V34.384a3.925,3.925,0,0,0-6.711-2.747L523.037,46.079a3.925,3.925,0,0,0,2.806,6.691h45.839a3.925,3.925,0,0,1,2.3,6.613L550.863,82.5a3.925,3.925,0,0,1-6.652-2.806V62.249h0a3.924,3.924,0,0,0-6.691-2.786l-23,23h0a3.925,3.925,0,0,1-6.711-2.728"
          transform="translate(474.262 3259.143)"
          fill="#fff"
        />
        <path
          id="Path_643"
          data-name="Path 643"
          d="M752.078,38.361V22.31a32.554,32.554,0,0,0-20.467-6.3A34.477,34.477,0,0,0,696.29,50.449c0,19.289,15.423,34.438,35.321,34.438a32.515,32.515,0,0,0,20.447-6.456V62.321c-4.788,3.925-11.479,7.437-18.308,7.437-11.479,0-20.369-7.712-20.369-19.368s8.34-19.368,20.369-19.368c7.005,0,13.226,3.493,18.308,7.359"
          transform="translate(655.634 3258.757)"
          fill="#fff"
        />
        <rect
          id="Rectangle_19"
          data-name="Rectangle 19"
          width="16.15"
          height="66.835"
          transform="translate(1420.525 3275.868)"
          fill="#fff"
        />
        <path
          id="Path_644"
          data-name="Path 644"
          d="M798.276,31.63V16.56h-53.3V31.63h18.583V83.4h16.052V31.63Z"
          transform="translate(702.487 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_645"
          data-name="Path 645"
          d="M840.7,16.56H822.591L807.422,41.324,792.273,16.56H774.24l25.215,41.267V83.4h16.052V57.827Z"
          transform="translate(730.644 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_646"
          data-name="Path 646"
          d="M903.166,55.845H891.589l5.75-18.661Zm5.475,14.972,4.494,12.559h16.621L905.619,16.56h-16.4L865,83.376h16.6l4.474-12.559Z"
          transform="translate(817.981 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_647"
          data-name="Path 647"
          d="M944.972,68.325H920.8V16.56H903.45V83.4h41.522Z"
          transform="translate(854.981 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_648"
          data-name="Path 648"
          d="M972.232,68.325H948.037V16.56H930.69V83.4h41.542Z"
          transform="translate(881.193 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_649"
          data-name="Path 649"
          d="M890.756,16.56h-15.5L859.968,43.384,844.485,16.56H829.16V83.4H844.9V44.9l1.217,1.923L857,65.872h5.828l11.3-19.407.9-1.57V83.4h15.718Z"
          transform="translate(783.492 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_650"
          data-name="Path 650"
          d="M1106,84.232V65.708h49.509V16.2h18.524V84.232ZM1141.87,52.07V16.18h-17.66V34.468H1106V52.129Z"
          transform="translate(1049.891 3258.941)"
          fill="#fff"
        />
        <path
          id="Path_651"
          data-name="Path 651"
          d="M1059.45,22.395l61.223,61.223H1059.45l19.623-19.9L1059.45,44.1Zm67.208,55.219V16.39h0l-19.9,19.623L1087.138,16.39h-21.585Z"
          transform="translate(1005.097 3259.143)"
          fill="#fff"
        />
        <path
          id="Path_652"
          data-name="Path 652"
          d="M1065.682,69.4V16.419h14.325V83.627H1012.7V69.4ZM1012.7,22.8V59.55h36.734Zm43.17,30.357V16.38H1019.1Z"
          transform="translate(960.11 3259.133)"
          fill="#fff"
        />
        <path
          id="Path_653"
          data-name="Path 653"
          d="M1033.246,69.587V30.5a14.129,14.129,0,0,0-28.257,0v4.14L994,23.65a14.7,14.7,0,1,0-20.783,20.783l10.991,10.986h-4.16a14.128,14.128,0,0,0,0,28.257h39.01a14.129,14.129,0,0,0,14.089-14.089"
          transform="translate(915.094 3259.124)"
          fill="#fff"
        />
        <path
          id="Path_654"
          data-name="Path 654"
          d="M1213.546,60.805c0,14.168-12.245,24.332-27.236,24.332-13.618,0-26.04-8.889-26.04-24.411V16.34H1176.6V57.8c0,8.359,4.356,11.97,9.713,11.97a9.811,9.811,0,0,0,9.988-10.086c0-10.989-6.534-17.15-6.358-28.041h17.072c0,9.811,6.534,17.072,6.534,29.218"
          transform="translate(1102.114 3259.095)"
          fill="#fff"
        />
        <path
          id="Path_655"
          data-name="Path 655"
          d="M1228.773,84.545V43.063c0-16.15-20.329-16.15-20.329,0V84.545H1192V45.3c0-16.424,8.811-29.67,26.51-29.67s26.51,13.245,26.51,29.689V84.565Z"
          transform="translate(1132.648 3258.412)"
          fill="#fff"
        />
        <path
          id="Path_656"
          data-name="Path 656"
          d="M1254.89,40.187c0-12.245-14.874-12.245-14.874,0V61.773c0,11.99,14.874,11.99,14.874,0Zm25.51-24.411c12.794,0,20.957,9.066,20.957,21.879V84.574h-16.346V39.187c0-10.891-13.736-10.891-13.736,0v19.78c0,15.7-9.066,26.962-23.783,26.962s-23.783-11.067-23.783-26.962V42.189c0-15.522,9.085-26.589,23.783-26.589a22.979,22.979,0,0,1,17.15,8.614,20.486,20.486,0,0,1,15.7-8.438"
          transform="translate(1163.162 3258.383)"
          fill="#fff"
        />
        <path
          id="Path_657"
          data-name="Path 657"
          d="M1304.515,84.545V43.063c0-16.15-20.329-16.15-20.329,0V84.545H1267.86V45.3c0-16.424,8.811-29.67,26.51-29.67s26.51,13.245,26.51,29.689V84.565Z"
          transform="translate(1205.647 3258.412)"
          fill="#fff"
        />
        <path
          id="Path_658"
          data-name="Path 658"
          d="M1347.12,45.192V40.738c0-6.436-3.807-9.988-11.165-9.988-8.359,0-17.072,4.533-22.508,8.163V23.489a47.1,47.1,0,0,1,23.783-7.849c15.7,0,26.236,9.439,26.236,26.039V60.655c0,15.875-12.618,25.235-26.059,25.235s-27.237-8.438-27.237-23.685,10.793-23.861,23.057-23.861a17.346,17.346,0,0,1,13.736,6.986ZM1327.5,62.068a9.654,9.654,0,0,0,9.812,10.067,9.812,9.812,0,0,0,9.812-10.067,9.811,9.811,0,0,0-9.812-10.263c-6.181,0-9.812,4.18-9.812,10.263"
          transform="translate(1246.361 3258.421)"
          fill="#fff"
        />
        <path
          id="Path_659"
          data-name="Path 659"
          d="M1398.59,15.62c-6.4,0-12.755,4.042-17.661,10.047-4.631-5.985-10.792-10.047-17.288-10.047-13.245,0-21.781,9.615-21.781,25.235V84.594h16.346V39.913c0-11.774,14.344-11.774,14.344,0V67.385h16.326V39.913c0-11.774,14.246-11.774,14.246,0v44.74h16.346v-43.8c0-15.7-7.712-25.235-20.957-25.235"
          transform="translate(1276.855 3258.402)"
          fill="#fff"
        />
        <path
          id="Path_660"
          data-name="Path 660"
          d="M1385.57,41.483c0-15.07,11.774-25.863,27.315-25.863,13.344,0,26.51,8.359,26.51,23.861,0,5.71-1.962,11.617-1.962,17.425h-16.875c0-5.357,1.727-11.774,1.727-16.15,0-6.534-4.356-10.518-9.812-10.518s-9.615,4.082-9.615,10.989,2.178,12.068,11.892,19.329,18.524,15.345,18.524,24.058H1415.75c0-5.357-3.728-6.907-12.245-6.907h-13.971V66.09H1399.6c-8.536-6.358-13.971-14.344-13.971-24.607"
          transform="translate(1318.917 3258.402)"
          fill="#fff"
        />
        <path
          id="Path_661"
          data-name="Path 661"
          d="M1453.785,84.565V43.083c0-16.15-20.329-16.15-20.329,0V84.565H1417.11V45.32c0-16.424,8.811-29.67,26.51-29.67s26.51,13.245,26.51,29.67V84.565Z"
          transform="translate(1349.268 3258.431)"
          fill="#fff"
        />
        <path
          id="Path_662"
          data-name="Path 662"
          d="M1599.54,83.246V16.43h66.875v6.22H1605.76v60.6Zm17.229.255V33.659h49.881v-6.3h-56.1V83.5Zm49.43-13.088-25.726-25.745h25.922v-6.2h-40.933L1661.8,74.808ZM1653.562,83.05l4.4-4.4-36.322-36.341V83.246h6.279V57.3Z"
          transform="translate(1524.817 3259.181)"
          fill="#fff"
        />
        <path
          id="Path_663"
          data-name="Path 663"
          d="M1517.308,28.268h8.654V49.657h19.113V68.769H1562.5V84.212h10.734V58.036h-17.425V38.923H1536.7V28.268h36.557V16.18H1505.22V84.212h12.088Z"
          transform="translate(1434.054 3258.941)"
          fill="#fff"
        />
        <path
          id="Path_664"
          data-name="Path 664"
          d="M1618.438,64.937h0l-24.666-24.666h24.666V16.39H1551.23V83.618h23.881V58.952l24.725,24.666h18.681Zm-46.722,15.286h-6.848v-50.2l6.848,6.848Zm19.623-23.547V70.549l-6.593-6.593V49.984ZM1554.7,19.785l6.848,6.848V80.2H1554.7Zm20.486,34.36V40.271l6.319,6.319V60.463l-3.925-3.925Zm19.623,19.623V59.972l6.593,6.593V80.3h-.236Zm9.988,6.377V69.96l10.263,10.263Z"
          transform="translate(1478.329 3259.143)"
          fill="#fff"
        />
        <path
          id="Path_665"
          data-name="Path 665"
          d="M1459.319,79.733V20.118a3.925,3.925,0,0,1,3.729-3.728H1522.6a3.925,3.925,0,0,1,2.787,6.711l-22.978,22.978a3.925,3.925,0,0,1-6.711-2.786V34.384a3.924,3.924,0,0,0-6.711-2.747l-14.462,14.442a3.924,3.924,0,0,0,2.787,6.691h45.839a3.924,3.924,0,0,1,2.3,6.613L1502.332,82.5a3.925,3.925,0,0,1-6.652-2.806V62.249h0a3.925,3.925,0,0,0-6.711-2.786l-22.978,22.978h0a3.924,3.924,0,0,1-6.711-2.728"
          transform="translate(1389.847 3259.143)"
          fill="#fff"
        />
        <path
          id="Path_666"
          data-name="Path 666"
          d="M1703.548,38.361V22.309a32.554,32.554,0,0,0-20.447-6.3,34.477,34.477,0,0,0-35.321,34.438c0,19.289,15.424,34.438,35.321,34.438a32.514,32.514,0,0,0,20.447-6.456V62.32c-4.788,3.925-11.479,7.437-18.308,7.437-11.479,0-20.368-7.712-20.368-19.368s8.34-19.368,20.368-19.368c7.005,0,13.226,3.493,18.308,7.359"
          transform="translate(1571.238 3258.757)"
          fill="#fff"
        />
        <rect
          id="Rectangle_20"
          data-name="Rectangle 20"
          width="16.15"
          height="66.835"
          transform="translate(3287.619 3275.868)"
          fill="#fff"
        />
        <path
          id="Path_667"
          data-name="Path 667"
          d="M1749.746,31.63V16.56H1696.47V31.63h18.563V83.4h16.051V31.63Z"
          transform="translate(1618.091 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_668"
          data-name="Path 668"
          d="M1792.2,16.56H1774.07l-15.149,24.764L1743.753,16.56H1725.72l25.215,41.267V83.4h16.052V57.827Z"
          transform="translate(1646.238 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_669"
          data-name="Path 669"
          d="M1854.627,55.845h-11.636l5.75-18.661Zm5.475,14.972,4.494,12.559h16.6L1857.06,16.56h-16.424L1816.5,83.376h16.679l4.494-12.559Z"
          transform="translate(1733.594 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_670"
          data-name="Path 670"
          d="M1896.471,68.325h-24.2V16.56H1854.93V83.4h41.542Z"
          transform="translate(1770.575 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_671"
          data-name="Path 671"
          d="M1923.7,68.325h-24.175V16.56H1882.18V83.4H1923.7Z"
          transform="translate(1796.797 3259.306)"
          fill="#fff"
        />
        <path
          id="Path_672"
          data-name="Path 672"
          d="M1842.246,16.56h-15.522l-15.286,26.824L1795.956,16.56H1780.65V83.4h15.718V44.9l1.236,1.923,10.891,19.054h5.828l11.283-19.407.9-1.57V83.4h15.738Z"
          transform="translate(1699.096 3259.306)"
          fill="#fff"
        />
      </g>
    </svg>

    <svg
      v-if="name === 'back'"
      xmlns="http://www.w3.org/2000/svg"
      width="7.857"
      height="10"
      viewBox="0 0 7.857 10"
    >
      <path
        id="Icon_material-play-arrow"
        data-name="Icon material-play-arrow"
        d="M19.857,7.5v10L12,12.5Z"
        transform="translate(-12 -7.5)"
        fill="#1a1a1a"
      />
    </svg>

    <svg
      v-if="name == 'logo'"
      xmlns="http://www.w3.org/2000/svg"
      width="205.886"
      height="26"
      viewBox="0 0 205.886 26"
    >
      <g
        id="Group_6468"
        data-name="Group 6468"
        transform="translate(-456.998 -328.09)"
      >
        <path
          id="Path_2941"
          data-name="Path 2941"
          d="M476.691,347.243c0,5.233-4.529,8.991-10.065,8.991-5.032,0-9.628-3.288-9.628-9.024V330.771h6.039V346.1c0,3.086,1.61,4.429,3.59,4.429a3.6,3.6,0,0,0,3.69-3.724c0-4.059-2.415-6.341-2.348-10.366h6.307c0,3.59,2.416,6.307,2.416,10.8"
          transform="translate(0 -2.144)"
          fill="#1a1a1a"
        />
        <path
          id="Path_2942"
          data-name="Path 2942"
          d="M585.63,353.587V338.256c0-5.972-7.515-5.972-7.515,0v15.331h-6.039V339.061c0-6.072,3.254-10.97,9.8-10.97s9.8,4.9,9.8,10.97v14.526Z"
          transform="translate(-92.03 -0.001)"
          fill="#1a1a1a"
        />
        <path
          id="Path_2943"
          data-name="Path 2943"
          d="M698.193,337.182c0-4.529-5.5-4.529-5.5,0v7.984c0,4.429,5.5,4.429,5.5,0Zm9.394-9.024c4.73,0,7.75,3.355,7.75,8.085v17.344H709.3V336.813c0-4.026-5.066-4.026-5.066,0v7.313c0,5.77-3.355,9.964-8.79,9.964-5.4,0-8.79-4.093-8.79-9.964V337.92c0-5.737,3.355-9.83,8.79-9.83a8.494,8.494,0,0,1,6.341,3.187,7.574,7.574,0,0,1,5.8-3.12"
          transform="translate(-183.66)"
          fill="#1a1a1a"
        />
        <path
          id="Path_2944"
          data-name="Path 2944"
          d="M860.178,353.587V338.256c0-5.972-7.515-5.972-7.515,0v15.331h-6.039V339.061c0-6.072,3.254-10.97,9.8-10.97s9.8,4.9,9.8,10.97v14.526Z"
          transform="translate(-311.593 -0.001)"
          fill="#1a1a1a"
        />
        <path
          id="Path_2945"
          data-name="Path 2945"
          d="M1013.382,339.111v-1.644c0-2.382-1.409-3.69-4.126-3.69-3.087,0-6.307,1.677-8.32,3.019v-5.7a17.428,17.428,0,0,1,8.79-2.919c5.838,0,9.7,3.489,9.7,9.628v7.012c0,5.871-4.663,9.326-9.628,9.326-5.032,0-10.065-3.12-10.065-8.756a8.38,8.38,0,0,1,8.521-8.823,6.405,6.405,0,0,1,5.1,2.583Zm-7.28,6.24a3.571,3.571,0,0,0,3.623,3.724,3.659,3.659,0,0,0,3.657-3.724,3.6,3.6,0,0,0-3.657-3.791,3.463,3.463,0,0,0-3.623,3.791"
          transform="translate(-434.033 -0.067)"
          fill="#1a1a1a"
        />
        <path
          id="Path_2946"
          data-name="Path 2946"
          d="M1135.741,328.174c-2.365,0-4.712,1.5-6.494,3.712-1.708-2.215-3.992-3.712-6.389-3.712-4.9,0-8.052,3.556-8.052,9.326v16.17h6.039V337.131c0-4.361,5.3-4.361,5.3,0V347.3h6.039V337.131c0-4.361,5.267-4.361,5.267,0v16.539h6.039V337.5c0-5.77-2.852-9.326-7.749-9.326"
          transform="translate(-526.065 -0.067)"
          fill="#1a1a1a"
        />
        <path
          id="Path_2947"
          data-name="Path 2947"
          d="M1272.936,337.735c0-5.569,4.328-9.561,10.1-9.561,4.932,0,9.8,3.086,9.8,8.823,0,2.114-.7,4.294-.7,6.441h-6.24c0-1.979.637-4.328.637-5.972a3.607,3.607,0,0,0-3.657-3.892c-2.046,0-3.556,1.51-3.556,4.059,0,2.482.805,4.462,4.4,7.146,3.556,2.684,6.844,5.67,6.844,8.89h-6.475c0-1.979-1.375-2.55-4.529-2.55h-5.167v-4.294h3.724c-3.153-2.348-5.166-5.3-5.166-9.092"
          transform="translate(-652.524 -0.067)"
          fill="#1a1a1a"
        />
        <path
          id="Path_2948"
          data-name="Path 2948"
          d="M1400.73,353.671V338.339c0-5.971-7.515-5.971-7.515,0v15.332h-6.039V339.144c0-6.072,3.254-10.97,9.8-10.97s9.8,4.9,9.8,10.97v14.526Z"
          transform="translate(-743.885 -0.067)"
          fill="#1a1a1a"
        />
      </g>
    </svg>

    <svg
      v-if="name == 'search_icon'"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        id="Path_3021"
        data-name="Path 3021"
        d="M19.556,17.383,15.433,13.26a8.231,8.231,0,0,0,1.491-4.8,8.312,8.312,0,0,0-.667-3.287A8.287,8.287,0,0,0,11.749.67a8.433,8.433,0,0,0-6.575,0A8.286,8.286,0,0,0,.667,5.177a8.433,8.433,0,0,0,0,6.574,8.289,8.289,0,0,0,4.507,4.507,8.315,8.315,0,0,0,3.287.667,8.232,8.232,0,0,0,4.8-1.49l4.123,4.111A1.428,1.428,0,0,0,18.462,20a1.538,1.538,0,0,0,1.094-2.62Zm-7.29-5.114a5.185,5.185,0,0,1-3.8,1.581,5.186,5.186,0,0,1-3.8-1.581,5.185,5.185,0,0,1-1.581-3.8,5.186,5.186,0,0,1,1.581-3.8,5.185,5.185,0,0,1,3.8-1.581,5.187,5.187,0,0,1,3.8,1.581,5.185,5.185,0,0,1,1.581,3.8A5.186,5.186,0,0,1,12.266,12.269Z"
        transform="translate(0 -0.003)"
        fill="#4d4d4f"
      />
    </svg>

    <!-- map svg -->

    <svg
      v-if="name == 'map'"
      version="1.1"
      id="Слой_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 2391.3 1900.5"
      style="enable-background:new 0 0 2391.3 1900.5;"
      xml:space="preserve"
    >
      <image
        style="overflow:visible;"
        width="3717"
        height="2954"
        xlink:href="@/assets/imgs/map_new.png"
        transform="matrix(0.6433 0 0 0.6433 0 0)"
      ></image>
      <polygon
        class="st0"
        points="68.5,757.7 68.5,1301 531.9,1301 531.9,1091.8 315.5,1091.8 315.5,757.7 "
      />
      <polygon
        class="st0"
        points="725.1,108.4 725.1,536.9 1008.4,536.9 1008.4,269.7 967.2,269.7 967.2,163.6 1001.1,163.6 
        1001.1,108.4 "
      />
      <polygon
        class="st0"
        points="1092.1,923.8 1092.1,1225 1620.9,1225 1620.9,1006.1 1647,923.8 1477.6,923.8 1477.6,898.6 
        1141.5,898.6 "
      />
    </svg>
    <svg
      v-if="name == 'mobile_logo_ge'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 253 144.96"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            class="cls-1"
            d="M51,44.08C51,57.64,39.3,67.38,25,67.38,11.91,67.38,0,58.86,0,44V1.39H15.65V41.12c0,8,4.17,11.48,9.3,11.48A9.34,9.34,0,0,0,34.52,43c0-10.52-6.26-16.43-6.09-26.87H44.77C44.77,25.39,51,32.43,51,44.08Z"
          />
          <path
            class="cls-1"
            d="M94.65,66.08V26.34c0-15.47-19.47-15.47-19.47,0V66.08H59.53V28.43C59.53,12.69,68,0,84.91,0S110.3,12.69,110.3,28.43V66.08Z"
          />
          <path
            class="cls-1"
            d="M148.29,23.56c0-11.74-14.26-11.74-14.26,0V44.25c0,11.48,14.26,11.48,14.26,0ZM172.64.17c12.26,0,20.08,8.7,20.08,21v45H177.07V22.6c0-10.43-13.13-10.43-13.13,0v19c0,14.95-8.69,25.82-22.78,25.82s-22.77-10.61-22.77-25.82V25.47C118.39,10.61,127.08,0,141.16,0c6,0,12.35,3.22,16.44,8.26C161.07,3.65,166.72.17,172.64.17Z"
          />
          <path
            class="cls-1"
            d="M237.35,66.08V26.34c0-15.47-19.47-15.47-19.47,0V66.08H202.23V28.43C202.23,12.69,210.66,0,227.61,0S253,12.69,253,28.43V66.08Z"
          />
          <path
            class="cls-1"
            d="M35.39,106v-4.26c0-6.17-3.66-9.56-10.7-9.56-8,0-16.34,4.34-21.56,7.82V85.23c4.09-3,14.26-7.56,22.78-7.56,15.13,0,25.12,9,25.12,25v18.17C51,136,39,145,26.08,145,13,145,0,136.88,0,122.27,0,107.92,10.35,99.4,22.08,99.4a16.59,16.59,0,0,1,13.22,6.7ZM16.52,122.18c0,5.48,3.91,9.65,9.39,9.65a9.48,9.48,0,0,0,9.48-9.65c0-5.82-4.09-9.82-9.48-9.82C20,112.36,16.52,116.36,16.52,122.18Z"
          />
          <path
            class="cls-1"
            d="M113.78,77.67c-6.13,0-12.21,3.88-16.83,9.62-4.43-5.74-10.34-9.62-16.56-9.62-12.69,0-20.86,9.21-20.86,24.17v41.9H75.18V100.88c0-11.3,13.73-11.3,13.73,0v26.34h15.65V100.88c0-11.3,13.65-11.3,13.65,0v42.86h15.65v-41.9C133.86,86.88,126.47,77.67,113.78,77.67Z"
          />
          <path
            class="cls-1"
            d="M142.4,102.45c0-14.44,11.21-24.78,26.17-24.78,12.78,0,25.38,8,25.38,22.86,0,5.48-1.82,11.13-1.82,16.7H176c0-5.13,1.65-11.22,1.65-15.48,0-6.26-4.18-10.08-9.48-10.08s-9.22,3.91-9.22,10.52c0,6.43,2.09,11.56,11.39,18.51s17.74,14.7,17.74,23H171.26c0-5.13-3.56-6.6-11.74-6.6H146.13V126h9.65C147.61,119.92,142.4,112.27,142.4,102.45Z"
          />
          <path
            class="cls-1"
            d="M237.22,143.74V104c0-15.47-19.47-15.47-19.47,0v39.73H202.1V106.1c0-15.74,8.43-28.43,25.38-28.43s25.39,12.69,25.39,28.43v37.64Z"
          />
        </g>
      </g>
    </svg>

    <svg
      v-if="name == 'mobile_logo_en'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 219.81 144.02"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            class="cls-1"
            d="M54.07,21.77V6.18C50.24,3.22,43.89,0,34.22,0,14.8,0,0,14.89,0,33.44,0,52.16,15,66.87,34.22,66.87c9.67,0,16-3.3,19.85-6.27V45c-4.64,3.74-11.14,7.23-17.76,7.23-11.15,0-19.77-7.49-19.77-18.81,0-11.06,8.1-18.81,19.77-18.81C43.1,14.63,49.15,18,54.07,21.77Z"
          />
          <rect class="cls-1" x="66.18" y="1.13" width="15.67" height="64.87" />
          <polygon
            class="cls-1"
            points="143.65 15.76 143.65 1.13 91.92 1.13 91.92 15.76 109.95 15.76 109.95 66 125.53 66 125.53 15.76 143.65 15.76"
          />
          <polygon
            class="cls-1"
            points="212.18 1.13 194.59 1.13 179.87 25.16 165.15 1.13 147.65 1.13 172.12 41.19 172.12 66 187.71 66 187.71 41.19 212.18 1.13"
          />
          <polygon
            class="cls-1"
            points="62.35 79.15 47.28 79.15 32.45 105.19 17.41 79.15 2.56 79.15 2.56 144.02 17.82 144.02 17.82 106.67 29.58 127.01 35.24 127.01 47.08 106.67 47.08 144.02 62.35 144.02 62.35 79.15"
          />
          <path
            class="cls-1"
            d="M106.44,117.29H95.2l5.58-18.11Zm5.31,14.54L116.1,144h16.11L108.79,79.15H92.85L69.43,144H85.54l4.35-12.19Z"
          />
          <polygon
            class="cls-1"
            points="175.43 129.39 154.27 129.39 154.27 79.15 138.6 79.15 138.6 144.02 175.43 144.02 175.43 129.39"
          />
          <polygon
            class="cls-1"
            points="219.81 129.39 198.65 129.39 198.65 79.15 182.97 79.15 182.97 144.02 219.81 144.02 219.81 129.39"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: ["name"]
};
</script>

<style></style>
